import React, { Fragment, useEffect, useState, Component, useCallback, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Progress, Label, Input, Spinner, Table, Col, Container, Row, Card, CardBody, CardHeader, Modal, ModalHeader, NavLink, Nav, NavItem, ModalBody, TabContent, TabPane, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link, useParams } from "react-router-dom";
import Expense from "../Dashboard/Expense";
import BestSellingProducts from "../Dashboard/BestSellingProducts";
import BestMarketing from "../Dashboard/BestMarketing";
import BestPartner from "../Dashboard/BestPartner";
import { api } from "../../config";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import Revenue from "../Dashboard/Revenue";
import Graph from "../Dashboard/Graph";
import logo from "../../assets/images/logo-sm.png";
import parse from "html-react-parser";
import classnames from "classnames";
import ModalImage from "react-modal-image";
import ReactApexChart from "react-apexcharts";
import { useReactToPrint } from "react-to-print";
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline, useMapEvents } from "react-leaflet";
import Fullscreen from "react-fullscreen-crossbrowser";
import { resetTransferState, getTransfer } from "../../store/transfer/action";

import moment from "moment";
import { getCivilBudget, resetCivilBudgetState } from "../../store/civilBudget/action";
import { getCivilProgression, resetCivilProgressionState } from "../../store/civilProgression/action";
import { getCivilOpname, resetCivilOpnameState } from "../../store/civilOpname/action";
// import { resetCompanyState, getCompany } from "../../store/company/action";
// import { getClient, resetClientState } from "../../store/client/action";
import { resetSalesState, getSales } from "../../store/sales/action";
// import { getBranch, resetBranchState } from "../../store/branch/action";
import { resetProductVarianState, getProductVarian } from "../../store/productVarian/action";
import { getDashboard, resetDashboardState } from "../../store/dashboard/action";
import { resetAssetState, getAsset } from "../../store/asset/action";
import { resetLegalState, getLegal } from "../../store/legal/action";
import { resetCivilBudgetScheduleState, getCivilBudgetSchedule as onGetCivilBudgetSchedules, addNewCivilBudgetSchedule as onAddNewCivilBudgetSchedule, updateCivilBudgetSchedule as onUpdateCivilBudgetSchedule, deleteCivilBudgetSchedule as onDeleteCivilBudgetSchedule, getCivilBudgetScheduleLoading } from "../../store/civilBudgetSchedule/action";
import { find, isEmpty } from "lodash";
import handleValidDate from "../../helpers/utils/handleValidDate";
import SimpleBar from "simplebar-react";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import CountUp from "react-countup";
import ExportDoc from "../../Components/Common/ExportDoc";
import { getBranch, getBranchOne } from "../../store/actions";
import PrintDocx from "../Dashboard/PrintDocx";
import Siteplan from "../Dashboard/Siteplan";
import ReportBooking from "../Dashboard/ReportBooking";
import { getAccTrans } from "../../store/accTrans/action";
import { getBankBranch, resetBankBranchState } from "../../store/bankBranch/action";

let greenIcon = new Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

let blueIcon = new Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

let yellowIcon = new Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

let greyIcon = new Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-grey.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const Dashboard = () => {
  document.title = "Dashboard";
  const authData = JSON.parse(localStorage.getItem("authUser"));
  const param = useParams();
  const clientId = authData?.data?.clientId ?? null;
  const { companyId, branchId } = param;
  const userData = authData?.data;
  const userType = authData?.data?.userType;
  const userRole = authData?.data?.userRole;

  const printSiteRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const [loadingPrintSite, setLoadingPrintSite] = useState(false);
  const dispatch = useDispatch();
  const date = new Date().getHours();

  const [modal, setModal] = useState(false);
  const [modalMaterial, setModalMaterial] = useState(false);
  const [label, setLabel] = useState([]);
  const [dashboard, setDashboard] = useState({});
  const [hasload, setHasload] = useState(false);
  const [isBuildingProgress, setIsBuildingProgress] = useState(false);
  const [isBuildingOpname, setIsBuildingOpname] = useState(false);
  const [isRincikProgress, setIsRincikProgress] = useState(false);
  const [info, setInfo] = useState([]);
  const [svg, setSVG] = useState("");
  const [svgProject, setSVGProject] = useState("");
  const [svgRincik, setSVGRincik] = useState("");
  const [salesHistoryList, setSalesHistoryList] = useState([]);
  const [salesList, setSalesList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [productList, setProductList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [block, setBlock] = useState([]);
  const [progressList, setProgressList] = useState([]);
  const [opnameList, setOpnameList] = useState([]);
  const [progressUnitList, setProgressUnitList] = useState([]);
  const [progressBlokList, setProgressBlockList] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const [assetList, setAssetList] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [scheduleDetail, setScheduleDetail] = useState([]);
  const [civilBudgetSelectList, setCivilBudgetSelectList] = useState([]);
  const [civilBudget, setCivilBudget] = useState([]);
  const [transferList, setTransferList] = useState([]);
  const [expense, setExpense] = useState([]);
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [unit, setUnit] = useState(0);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const expanseDataRef = useRef([]);
  const [legalList, setLegalList] = useState([]);
  const [isFullscreenMap, setIsFullscreenMap] = useState(false);
  const [filterBy, setFilterBy] = useState("");
  const [chartProjectCategory, setChartProjectCategory] = useState([]);
  const [chartProjectColor, setChartProjectColor] = useState([]);
  const [chartProjectData, setChartProjectData] = useState([
    {
      name: "RAB",
      type: "line",
      data: [],
    },
    {
      name: "RAP",
      type: "line",
      data: [],
    },
  ]);

  const [isOpenImage, setIsOpenImage] = useState(false);
  const [imageActive, setImageActive] = useState({
    index: 0,
    urls: [],
  });

  const [landTotal, setLandTotal] = useState(false);
  const [landPaidTotal, setLandPaidTotal] = useState(false);
  const [landUnpaidTotal, setLandUnpaidTotal] = useState(false);
  const [priceTotal, setPriceTotal] = useState(false);
  const [paidTotal, setPaidTotal] = useState(false);
  const [legalStatus, setLegalStatus] = useState(false);
  const [accTransData, setAccTransData] = useState([]);

  const { accTranss, loadingAccTranss, dashboards, loading, error, branch, branchLoading, productVarians, productVarianLoading, saless, salesLoading, civilBudgets, civilBudgetLoading, civilProgressions, civilProgressionLoading, civilBudgetSchedules, civilBudgetScheduleLoading, assets, assetLoading, legals, legalLoading, transfers, transferLoading, bankBranches } = useSelector((state) => ({
    dashboards: state.Dashboard.dashboards,
    loading: state.Dashboard.loading,
    catalogAvailable: state.Catalog.catalogAvailable,
    branch: state.Branch.branch,
    branchLoading: state.Branch.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    civilProgressions: state.CivilProgression.civilProgressions,
    civilProgressionLoading: state.CivilProgression.loading,
    civilBudgetSchedules: state.CivilBudgetSchedule.civilBudgetSchedules,
    civilBudgetScheduleLoading: state.CivilBudgetSchedule.loading,
    saless: state.Sales.saless,
    salesLoading: state.Sales.loading,
    assets: state.Asset.assets,
    assetLoading: state.Asset.loading,
    legals: state.Legal.legals,
    legalLoading: state.Legal.loading,
    transfers: state.Transfer.transfers,
    transferLoading: state.Transfer.loading,
    accTranss: state.AccTrans.accTranss,
    loadingAccTranss: state.AccTrans.loading,
    bankBranches: state.BankBranch.bankBranches,
  }));

  const reactToPrintContent = useCallback(() => {
    return printSiteRef.current;
  }, [printSiteRef]);

  const handleAfterPrint = useCallback(() => {}, []);

  const handleBeforePrint = useCallback(() => {}, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrintSite(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrintSite(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrintSite]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <i className="ri-image-line me-1  align-bottom text-info "></i>;
    }
  };

  useEffect(() => {
    dispatch(getBranchOne(branchId));
  }, []);

  useEffect(() => {
    if (branch) {
      setPositionMessage(`${userData?.user?.user_department?.name}, ${userData?.user?.user_position?.name}`);
      handleGetDefault(clientId, companyId, branchId, branch.svg_siteplan, branch.svg_rincik, branch.svg_siteplan_project);
    }
  }, [branch]);

  useEffect(() => {
    if (!isEmpty(dashboards)) {
      setDashboard(dashboards);
    } else {
      setDashboard({});
    }
  }, [dashboards]);

  const handleGetProductVariant = (companyId, branchId, type) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, branchId: branchId, type: type, status: 2 }));
  };

  const handleGetSales = (companyId, branchId) => {
    dispatch(resetSalesState());
    dispatch(getSales({ companyId: companyId, branchId: branchId, simple: "true", date: "all" }));
  };

  const handleGetTransfer = (id) => {
    dispatch(resetTransferState());
    dispatch(getTransfer({ companyId: id }));
  };

  const handleCivilBudget = (id, branchId, type) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: id, branchId: branchId }));
  };

  const handleCivilProgression = (id, product) => {
    dispatch(resetCivilProgressionState());
    dispatch(getCivilProgression(product ? { companyId: id, productId: product } : { companyId: id }));
  };

  const handleCivilOpname = (id, product) => {
    dispatch(resetCivilOpnameState());
    dispatch(getCivilOpname({ companyId: id, productId: product }));
  };

  const [justifyPillsTab, setjustifyPillsTab] = useState("1");
  const justifyPillsToggle = (tab) => {
    if (justifyPillsTab !== tab) {
      setjustifyPillsTab(tab);
    }
  };

  const handleGetDefault = (clientId, companyId, branchId, svg, svg_rincik, svg_siteplan_project) => {
    dispatch(resetDashboardState());
    dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId }));
    handleCivilBudget(companyId, branchId, "PROGRESS BANGUNAN");
    handleGetProductVariant(companyId, branchId, 1);
    handleGetTransfer(companyId);
    handleGetSales(companyId, branchId);
    dispatch(resetBankBranchState());
    dispatch(getBankBranch({ companyId: companyId ?? "", sales: true, branchId: branchId }));
    setSVG(svg);
    setSVGProject(svg_siteplan_project);
    setSVGRincik(svg_rincik);
    handleCivilProgression(companyId);

    dispatch(resetAssetState());
    dispatch(getAsset({ companyId: companyId }));
    dispatch(resetLegalState());
    dispatch(getLegal({ companyId: companyId }));
  };

  const toggle = useCallback(() => {
    if (modal) {
      handleCivilProgression(companyId);
      setModal(false);
      setAccTransData([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  useEffect(() => {
    setProductList(productVarians);
  }, [productVarians]);

  // useEffect(() => {
  //   let data = [];
  //   let opt = [];
  //   (companies || []).forEach((item, key) => {
  //     const name = item.name;
  //     const id = item.id;
  //     let obj = { label: name, value: id };
  //     opt.push(obj);
  //   });
  //   let option = { options: opt };
  //   data.push(option);

  //   if (companies.length > 0) {
  //     setCompanyList(data);
  //   }
  // }, [companies]);

  // useEffect(() => {
  //   if (!isEmpty(clients)) {
  //     let data = [];
  //     let opt = [];
  //     clients.forEach((item, key) => {
  //       const name = item.name;
  //       const id = item.id;
  //       let obj = { label: name, value: id };
  //       opt.push(obj);
  //     });
  //     let option = { options: opt };
  //     data.push(option);
  //     setClientList(data);
  //   }
  // }, [clients]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      let arr = [];
      transfers.forEach((element, key) => {
        if (element.statusId === 2 || element.statusId === 3 || element.statusId === 4 || element.statusId === 5) {
          element.transfer_detail.forEach((el, key) => {
            el.blockId = element.blockId;
            arr.push(el);
          });
        }
      });
      setTransferList(arr);
    }
  }, [transfers]);

  useEffect(() => {
    let data = [];
    let location = [];
    if (!isEmpty(assets)) {
      assets.forEach((item, key) => {
        if (item.latitude) location.push([item.latitude, item.longitude]);
        item.type = "asset";
        data.push(item);
      });
    }

    if (!isEmpty(legals)) {
      legals.forEach((item, key) => {
        let latitude = parseFloat(item.latitude) || 0;
        let longitude = parseFloat(item.longitude) || 0;

        if (item.latitude) location.push([latitude, longitude]);
        item.type = "nominatif";
        data.push(item);
      });
    }
    setAssetList(data);
    setLocationCord(location);
  }, [assets, legals]);

  useEffect(() => {
    let list = [];
    let data = [];
    let opt = [];
    civilBudgets.forEach((it, idx) => {
      const name = it.cvl_branch ? it.cvl_branch.name + " - " + it.name : it.name;
      const id = it.id;
      if (it.cvl_branch.id === 1 && companyId && it) {
        if (it.type === "PROGRESS BANGUNAN") {
          dispatch(resetCivilBudgetScheduleState());
          dispatch(onGetCivilBudgetSchedules({ civilBudgetId: it.id }));
        }
        setCivilBudget({ label: name, value: id, data: it });
      }
      let obj = { label: name, value: id, data: it };
      opt.push(obj);
      (it.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order) || []).forEach((item, key) => {
        let cat = item.cvld_account && item.cvld_account.cvl_account_category ? item.cvld_account.cvl_account_category.name : "";
        let findCategory = list.find((x) => x.category === cat);
        if (findCategory) {
          findCategory.data.push(item);
        } else {
          list.push({ type: it.type, category: cat, data: [item] });
        }
      });
    });
    setCivilBudgetList(list);

    let option = { options: opt };
    data.push(option);
    setCivilBudgetSelectList(data);
  }, [civilBudgets]);

  // useEffect(() => {
  //   if (!isEmpty(branches)) {
  //     let data = [];
  //     let opt = [];
  //     (branches || []).forEach((item, key) => {
  //       const name = item.name;
  //       const id = item.id;
  //       let obj = { label: name, value: id, companyId: item.companyId, svg_siteplan_project: item.svg_siteplan_project, svg_siteplan: item.svg_siteplan, svg_rincik: item.svg_rincik, branch_code: item.branch_code };
  //       opt.push(obj);
  //       if (id === 1) {
  //         handleGetDefault(item.companyId, id, item.svg_siteplan, item.svg_rincik, item.svg_siteplan_project);
  //         setBranchSelect(obj);
  //       }
  //     });
  //     let option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })) };
  //     data.push(option);
  //     setBranchList(data);
  //   }
  // }, [branches, companySelected]);

  useEffect(() => {
    if (!isEmpty(legals)) {
      setLegalList(legals);
    }
  }, [legals]);

  useEffect(() => {
    let land = 0;
    let landPaid = 0;
    let landUnpaid = 0;
    let price = 0;
    let paid = 0;
    let arr = [];
    for (const obj of legalList) {
      land = land + parseFloat(obj.quantity || 0);
      let pd = 0;
      for (const p of obj.legal_trans) {
        if (p.statusId === 2 || p.statusId === 3) pd = pd + parseFloat(p.amount || 0);
      }
      paid = paid + pd;
      price = price + parseFloat(obj.price || 0);

      landUnpaid += pd >= obj.price ? 0 : parseFloat(obj.quantity || 0);
      landPaid += pd >= obj.price ? parseFloat(obj.quantity || 0) : 0;

      let findStatus = arr.find((f) => f.label === obj?.legal_status_legal?.name);
      if (findStatus) {
        findStatus.amount = findStatus.amount + 1;
      } else {
        arr.push({ id: obj?.legal_status_legal?.id, label: obj?.legal_status_legal?.name, amount: 1 });
      }
    }
    setLegalStatus(arr);
    setLandTotal(land);
    setLandPaidTotal(landPaid);
    setLandUnpaidTotal(landUnpaid);
    setPaidTotal(paid);
    setPriceTotal(price);
  }, [legalList]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    if (!isEmpty(civilBudgetSchedules)) {
      setSchedule(civilBudgetSchedules.schedule);
      setScheduleDetail(civilBudgetSchedules.schedule_detail);

      let chartCategory = [];
      let rab = [];
      let rap = [];
      let total_rab = 0;
      let total_rap = 0;
      for (const schedule of civilBudgetSchedules.schedule) {
        chartCategory.push(schedule.date);
        total_rab += parseFloat(schedule.total) > 0 ? parseFloat(schedule.total) : 0;
        total_rap += parseFloat(schedule.total_progress) > 0 ? parseFloat(schedule.total_progress) : 0;
        rab.push(total_rab.toFixed(2));
        //if (parseFloat(schedule.total_progress) > 0)
        rap.push(total_rap.toFixed(2));
        //else
        //  rap.push(0);
      }
      setChartProjectCategory(chartCategory);
      setChartProjectData([
        {
          name: "Rencana Anggaran Belanja",
          type: "line",
          data: rab,
        },
        {
          name: "Rencana Anggaran Pelaksanaan",
          type: "line",
          data: rap,
        },
      ]);

      setChartProjectColor(["#338b39", "#ffaa00"]);
    }
  }, [civilBudgetSchedules]);

  useEffect(() => {
    let arrProgress = [];
    let arrProgressBlock = [];
    let arrBlok = [];
    for (const varian of productList) {
      let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
      let name = varian.pvar_product.name;
      let prod = block + "-" + name;
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];
      let weight = 0;

      let findBlok = arrBlok.find((x) => x.block === block);
      if (!findBlok) {
        arrBlok.push({ block: block, weight: 0, label: block, unit: 1, value: varian?.pvar_product?.product_block?.id });
      } else {
        findBlok.unit += 1;
      }

      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        let unit = detail.cvlp_product && detail.cvlp_product.name;
        let key = blok + "-" + unit;
        if (prod === key) {
          for (const acc of civilBudgets) {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf(account.cvld_account.id.toString());
              if (findCategory !== -1) weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
            }
          }
        }
      }
      arrProgress.push({
        name: prod,
        block: block,
        weight: weight.toFixed(2),
      });
    }
    setProgressUnitList(arrProgress.sort((a, b) => (b.name === a.name ? 0 : a.name > b.name ? 1 : -1)));

    arrProgress = [];
    for (const varian of arrBlok) {
      let block = varian.block ? varian.block : "";
      let weight = 0;
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];

      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        if (block === blok) {
          for (const acc of civilBudgets) {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf(account.cvld_account.id.toString());
              if (findCategory !== -1) weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
            }
          }
        }
      }
      arrProgressBlock.push({
        block: block,
        weight: weight.toFixed(2),
      });
    }

    setProgressBlockList(
      arrProgressBlock.sort((a, b) => {
        a = a.block.replace(/(\d+)(.)/, "$2$1");
        b = b.block.replace(/(\d+)(.)/, "$2$1");
        return a.localeCompare(b, "en", { numeric: true });
      })
    );

    let data = [];
    let option = { options: arrBlok.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
    data.push(option);

    setBlockList(data);
  }, [dashboards, civilBudgets, productList]);

  useEffect(() => {
    if (!civilBudgetLoading && !loading && !productVarianLoading && isBuildingProgress) {
      const containerSvgEl = document.getElementById("_0");

      if (containerSvgEl) {
        containerSvgEl.childNodes.forEach((el) => {
          if (el.nodeType === 1) {
            el.style.fill = "";
          }
        });
      }

      for (const varian of productList) {
        let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
        let name = varian.pvar_product.name;
        let ele = document.getElementById(block + "-" + name);
        if (ele) {
          ele.removeAttribute("class");
          ele.style.fill = "#FFFFFF";
        }
      }

      let arrProgress = [];
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];
      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        let category = detail.cvlp_product && detail.cvlp_product.product_category && detail.cvlp_product.product_category.name;
        let unit = detail.cvlp_product && detail.cvlp_product.name;
        let image = detail.cvlp_product && detail.cvlp_product.image ? `${api.MEDIA_URL}/media/${detail.cvlp_product.image}-w-150` : logo;
        let key = blok + "-" + unit;
        detail.key = key;
        detail.name = category + " - " + key;
        detail.image = image;
        let weight = 0;
        for (const acc of civilBudgets) {
          if (acc.type === "PROGRESS BANGUNAN") {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf(account.cvld_account.id.toString());
              if (findCategory !== -1) {
                weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
                let ele = document.getElementById(blok + "-" + unit);
                detail.progress = account.cvld_account.name;
                detail.color = account.cvld_account.color;
                if (ele) {
                  ele.removeAttribute("class");
                  ele.style.fill = account.cvld_account.color;
                }
              }
            }
          }
        }
        detail.weight = weight.toFixed(2);
        arrProgress.push(detail);
      }
      setProgressList(arrProgress);
    }
  }, [svg, isBuildingProgress, dashboards, civilBudgets, civilBudgetLoading, productList, productVarianLoading, justifyPillsTab]);

  useEffect(() => {
    if (!civilBudgetLoading && !loading && !productVarianLoading && isBuildingOpname) {
      const containerSvgEl = document.getElementById("_0");

      if (containerSvgEl) {
        containerSvgEl.childNodes.forEach((el) => {
          if (el.nodeType === 1) {
            el.style.fill = "";
          }
        });
      }

      for (const varian of productList) {
        let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
        let name = varian.pvar_product.name;
        let ele = document.getElementById(block + "-" + name);
        if (ele) {
          ele.removeAttribute("class");
          ele.style.fill = "#FFFFFF";
        }
      }

      let arrOpname = [];
      let progress = dashboards.civil_opname ? dashboards.civil_opname : [];
      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlop_product && detail.cvlop_product.product_block && detail.cvlop_product.product_block.name;
        let category = detail.cvlop_product && detail.cvlop_product.product_category && detail.cvlop_product.product_category.name;
        let unit = detail.cvlop_product && detail.cvlop_product.name;
        let image = detail.cvlop_product && detail.cvlop_product.image ? `${api.MEDIA_URL}/media/${detail.cvlop_product.image}-w-150` : logo;
        let key = blok + "-" + unit;
        detail.key = key;
        detail.name = category + " - " + key;
        detail.image = image;
        let weight = 0;
        for (const acc of civilBudgets) {
          if (acc.type === "UPAH") {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf(account.cvld_account.id.toString());
              if (findCategory !== -1) {
                weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
                let ele = document.getElementById(blok + "-" + unit);
                detail.progress = account.cvld_account.name;
                detail.color = account.cvld_account.color;
                if (ele) {
                  ele.removeAttribute("class");
                  ele.style.fill = account.cvld_account.color;
                }
              }
            }
          }
        }
        detail.weight = weight.toFixed(2);
        arrOpname.push(detail);
      }

      setOpnameList(arrOpname);
    }
  }, [svg, isBuildingOpname, dashboards, civilBudgets, civilBudgetLoading, productList, productVarianLoading, justifyPillsTab]);

  useEffect(() => {
    if (!salesLoading && !productVarianLoading && !isBuildingProgress && !isBuildingOpname) {
      const containerSvgEl = document.getElementById("_0");

      if (containerSvgEl) {
        containerSvgEl.childNodes.forEach((el) => {
          if (el.nodeType === 1) {
            el.style.fill = "";
          }
        });
      }

      for (const varian of productList) {
        let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
        let name = varian.pvar_product.name;
        let ele = document.getElementById(block + "-" + name);
        if (ele) {
          ele.removeAttribute("class");
          ele.style.fill = "#FFFFFF";
        }
      }

      let arrHistory = [];
      let arrSales = [];

      for (const sales of saless) {
        let color = "";
        switch (sales.statusDealId) {
          case 3:
            color = "#ed57f7";
            break;
          case 4:
            color = "#BDB395"; //75fb4c
            break;
          case 5:
            color = "#75fb4c";
            break;
          case 6:
            color = "#FFC107";
            break;
          case 7:
            color = "#9ACBD0";
            break;
          case 8:
            color = "#75fbfd";
            break;
          default:
            color = "";
            break;
        }
        for (const item of sales.sales_history) {
          item.sales = sales;
          arrHistory.push(item);
        }
        if (sales.typeId === 4 || sales.typeId === 3) color = "#20A7DB";

        for (const detail of sales.sales_detail) {
          let blok = detail.sales_detail_product && detail.sales_detail_product.product_block && detail.sales_detail_product.product_block.name;
          let category = detail.sales_detail_product && detail.sales_detail_product.product_category && detail.sales_detail_product.product_category.name;
          let unit = detail.sales_detail_product && detail.sales_detail_product.name;
          let image = detail.sales_detail_product && detail.sales_detail_product.image ? `${api.MEDIA_URL}/media/${detail.sales_detail_product.image}-w-150` : logo;
          let key = blok + "-" + unit;
          sales.key = key;
          sales.name = category + " " + key;
          sales.image = image;
          arrSales.push(sales);
          let ele = document.getElementById(blok + "-" + unit);
          if (ele) {
            ele.style.fill = color;
          }
        }
      }
      setSalesList(arrSales);
      if (arrHistory.length) setSalesHistoryList(arrHistory);
      else setSalesHistoryList([]);
    }
  }, [svg, saless, salesLoading, isBuildingProgress, productList, productVarianLoading, justifyPillsTab]);

  useEffect(() => {
    document.body.addEventListener("click", (element) => {
      if (element.target.id) {
        let data = isBuildingProgress ? progressList.find((x) => x.key === element.target.id) : isBuildingOpname ? opnameList.find((x) => x.key === element.target.id) : salesList.find((x) => x.key === element.target.id);
        if (data) {
          if (isBuildingProgress) handleCivilProgression(data.companyId, data.productId);
          if (isBuildingOpname) handleCivilOpname(data.companyId, data.productId);
          setInfo(data);

          const sales = salesList.find((x) => x.key === element.target.id);
          if (sales) {
            dispatch(getAccTrans({ salesId: sales.id, date: "all" }));
          }

          console.log("click");
          toggle();
        }
      }
    });

    document.body.addEventListener("mouseover", (element) => {
      if (element.target.id) {
        let data = isBuildingProgress ? progressList.find((x) => x.key === element.target.id) : isBuildingOpname ? opnameList.find((x) => x.key === element.target.id) : salesList.find((x) => x.key === element.target.id);
        if (data) {
          setInfo(data);
          let iconPos = document.querySelector("#" + data.key).getBoundingClientRect();
          let mypopup = document.getElementById("dashboard-custom-tooltip");
          mypopup.style.left = iconPos.right < 1000 ? iconPos.right + 10 + "px" : iconPos.right - 460 + 10 + "px";
          mypopup.style.top = window.scrollY + iconPos.top - 60 + "px";
          mypopup.style.display = "block";
        }
      }
    });

    document.body.addEventListener("mouseout", (element) => {
      if (element.target.id) {
        let data = isBuildingProgress ? progressList.find((x) => x.key === element.target.id) : isBuildingOpname ? opnameList.find((x) => x.key === element.target.id) : salesList.find((x) => x.key === element.target.id);
        if (data) {
          let mypopup = document.getElementById("dashboard-custom-tooltip");
          mypopup.style.display = "none";
        }
      }
    });
  }, [salesList, progressList, isBuildingProgress, isBuildingOpname]);

  const toggleMaterial = useCallback(() => {
    if (modalMaterial) {
      setModalMaterial(false);
    } else {
      setModalMaterial(true);
    }
  }, [modalMaterial]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "name",
        label: "Material",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "amount" || doc.id === "quantity" || doc.id === "amount_total") {
                doc.data.push(currencyFormat(parseFloat(value || 0) || 0));
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return el.amount.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.description.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.transaction_no.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  const [initialPosition, setInitialPosition] = useState([0, 0]);
  const [selectedPosition, setSelectedPosition] = useState([0, 0]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      setInitialPosition([latitude, longitude]);
    });
  }, []);

  const Markers = () => {
    const map = useMapEvents({
      click(e) {
        console.log("", e.latlng.lat + ", " + e.latlng.lng);
        setSelectedPosition([e.latlng.lat, e.latlng.lng]);
      },
    });

    return selectedPosition ? (
      <Marker key={selectedPosition[0]} position={selectedPosition} interactive={false}>
        <Popup maxWidth="480" maxHeight="auto">
          <div style={{ width: "480px" }}>{selectedPosition}</div>
        </Popup>
      </Marker>
    ) : null;
  };

  // const polyline = [
  //   [-6.45543862539251, 106.985199676624], [-6.45554313920498, 106.985163460925], [-6.45577933984497, 106.985081610027], [-6.45590263240001, 106.985038883237], [-6.45590267376998, 106.985038870647], [-6.45590307037002, 106.985038732152], [-6.45595787235748, 106.98499775724], [-6.45595029017249, 106.984984863659], [-6.45600819752002, 106.984954839795], [-6.456031257935, 106.984942883307], [-6.45612673086498, 106.984871494224], [-6.45613870443747, 106.984862541472], [-6.45616378113244, 106.984843791507], [-6.4561639205275, 106.984843686287], [-6.45618019915743, 106.984831515762], [-6.45623456677245, 106.984790862807], [-6.45630542525497, 106.98473787835], [-6.4565033975125, 106.984567702337], [-6.4566210279375, 106.984466588862], [-6.45662925583501, 106.984465283047], [-6.45662844914248, 106.98446025224], [-6.45662961916249, 106.98446522639], [-6.45678075382749, 106.985107603132], [-6.4569116222725, 106.98575005722], [-6.45689972424247, 106.985904722624], [-6.45676885759752, 106.985976102714], [-6.45649521908001, 106.985976106312], [-6.45639261182999, 106.986017148672], [-6.45637624506747, 106.986023695737], [-6.45631675671251, 106.986178358445], [-6.45641193556252, 106.986559072942], [-6.45649521728, 106.986915994077], [-6.45660960924496, 106.98691599138], [-6.45661419039245, 106.986915991379], [-6.45682655809997, 106.986873569459], [-6.456835187095, 106.986871845459], [-6.45683618264252, 106.986870139444], [-6.45694646560747, 106.98668127462], [-6.457077713565, 106.986562993987], [-6.45708446477499, 106.986556909175], [-6.45712084145246, 106.986524126187], [-6.45716600990245, 106.986474407167], [-6.45718662506245, 106.986451716372], [-6.45721586472001, 106.986419530537], [-6.45751838676501, 106.98634492188], [-6.45754277997497, 106.9863458239], [-6.45783961290749, 106.986356819012], [-6.45800645333496, 106.986310475147], [-6.45805376396998, 106.986297331557], [-6.45810360529748, 106.98626486873], [-6.458201689855, 106.98620098269], [-6.45827505025249, 106.98615319991], [-6.45828100376502, 106.985798240197], [-6.45832383307747, 106.985684026297], [-6.45813775075747, 106.985574907057], [-6.45811839015249, 106.985481192302], [-6.45812617827999, 106.985372552402], [-6.45812629429253, 106.985370931822], [-6.45813013169999, 106.985317409569], [-6.45817585053497, 106.985298912315], [-6.45822012235998, 106.985295014652], [-6.45826254607997, 106.98529127977], [-6.45830263245996, 106.98528774993], [-6.45841610082248, 106.985277757562], [-6.4586821805375, 106.985254330222], [-6.45869251374748, 106.985253421007], [-6.45876812784751, 106.985156575714], [-6.45878532827999, 106.985113454122], [-6.45882352068997, 106.985017703305], [-6.45890025983997, 106.984894625687], [-6.45890405227998, 106.984781088975], [-6.45890721069997, 106.984686498282], [-6.45890918021501, 106.984627546824], [-6.4588242329525, 106.984485621215], [-6.458823406475, 106.984484239855], [-6.45879556976001, 106.984437729617], [-6.45875478010998, 106.984369579892], [-6.45875384211502, 106.984368015072], [-6.45859509108998, 106.984142135052], [-6.45840949530247, 106.983870877039], [-6.45833810981495, 106.983713832027], [-6.45834084285502, 106.983696073115], [-6.45836666509001, 106.983528236239], [-6.45848087988745, 106.983328361015], [-6.45862364366502, 106.983228422952], [-6.45868261760749, 106.983061329817], [-6.45870930498998, 106.982985716617], [-6.45862364456503, 106.982714458605], [-6.45861997623001, 106.982685110129], [-6.45859509108999, 106.982486028107], [-6.45856466432751, 106.982268786075], [-6.45856174512747, 106.982247929897], [-6.45856744592996, 106.98224727789], [-6.4585682121525, 106.982247188857], [-6.45857691309499, 106.982246194207], [-6.4587098913475, 106.982230984872], [-6.45895285669001, 106.982203200317], [-6.45895531363748, 106.98220291973], [-6.4590477315675, 106.982192349997], [-6.459049036485, 106.98219220071], [-6.45904958147248, 106.982192138657], [-6.45904976133749, 106.982192118872], [-6.45904991691996, 106.982192100885], [-6.45905045471499, 106.982192038832], [-6.45905096463002, 106.982191979477], [-6.45905419229751, 106.982191611652], [-6.45906609302499, 106.98219025098], [-6.45908132124494, 106.982188508992], [-6.45909358889747, 106.982107572707], [-6.45911779145251, 106.981947899875], [-6.45914130512748, 106.98179277132], [-6.45914659763753, 106.98175785604], [-6.45914694207749, 106.981755587049], [-6.45914802396247, 106.981748446432], [-6.459149613065, 106.981737970232], [-6.45915098273251, 106.98172892395], [-6.4591584237225, 106.981679833557], [-6.45916627839998, 106.981628006527], [-6.45917185419749, 106.981591226952], [-6.45917346218499, 106.981580604162], [-6.45917374547252, 106.981578729075], [-6.45917763773752, 106.981553057027], [-6.45918759773001, 106.98148735256], [-6.45962756945749, 106.981426043977], [-6.45966573218746, 106.981420727185], [-6.459671612855, 106.981419907902], [-6.459702786055, 106.98141556148], [-6.4597121210175, 106.981414262857], [-6.45973781644746, 106.981410682657], [-6.45981820594499, 106.9813994816], [-6.45988368100639, 106.981390357107], [-6.45980133441631, 106.980786344238], [-6.45579194035401, 106.98147622063], [-6.45540800607427, 106.981785611504], [-6.45498457485353, 106.981871649825], [-6.45501950137835, 106.982116905445], [-6.45456457401181, 106.982228727939], [-6.45459356689056, 106.982462003189], [-6.45455726761362, 106.982569475411], [-6.45443722409668, 106.982682600326], [-6.45384456906538, 106.982841714609], [-6.45329321601852, 106.98314447357], [-6.45318189992502, 106.983217160742], [-6.45340570520999, 106.98349622757], [-6.45343317769998, 106.983563459985], [-6.45354076629251, 106.983826766192], [-6.45358345441252, 106.983882441422], [-6.45366214599, 106.983985071155], [-6.45371099896248, 106.984034292847], [-6.45377651637248, 106.984100303985], [-6.45381864961, 106.98433721689], [-6.45389641128998, 106.984638836912], [-6.4539385175475, 106.984882923707], [-6.454003085275, 106.984840252674], [-6.45409469561253, 106.984779710315], [-6.45415435933501, 106.98474027954], [-6.45426889879002, 106.98481246902], [-6.45444796460245, 106.984899255397], [-6.45460620031501, 106.984806608137], [-6.45483591864249, 106.984785980389], [-6.4550012760875, 106.984707706994], [-6.45515225247498, 106.984636554432], [-6.45531023907497, 106.984608471305], [-6.45539640851752, 106.984594457167], [-6.45542334231244, 106.984703975707], [-6.45542420476249, 106.98470748756], [-6.45542466341748, 106.984709356352], [-6.45540957549252, 106.984747465122], [-6.45535943648752, 106.984874106755], [-6.45531582027002, 106.985017424514], [-6.45541918384748, 106.985206414345], [-6.45541922341745, 106.985206400855], [-6.45543393452748, 106.985201303497], [-6.45543862539251, 106.985199676624]
  // ]
  // const limeOptions = { color: 'lime' }

  // const polyline1 = [
  //   [-6.456847529214942, 106.98129460215569], [-6.456873636490386, 106.9814709575918], [-6.457224580031053, 106.98141037641221], [-6.457198855972422, 106.98123425245286], [-6.456847529214942, 106.98129460215569]
  // ] //No Bid A24
  // const polyline2 = [
  //   [-6.457198855972422, 106.98123425245286], [-6.457224580031053, 106.98141037641221], [-6.457573315515911, 106.98135897517204], [-6.457546788531128, 106.98117256164552], [-6.457198855972422, 106.98123425245286]
  // ] //No Bid A23
  // const polyline3 = [
  //   [-6.456873636490386, 106.9814709575918], [-6.45690127035668, 106.98162987828256], [-6.457250452449548, 106.98157221078874], [-6.457224580031053, 106.98141037641221], [-6.456873636490386, 106.9814709575918]
  // ] //No Bid A25
  // const polyline4 = [
  //   [-6.457229089254814, 106.98140859603883], [-6.45725174339742, 106.98156952857973], [-6.457603548775938, 106.98151722550394], [-6.45757689686188, 106.98135897517204], [-6.457229089254814, 106.98140859603883]
  // ] //No Bid A22
  // const polyline5 = [
  //   [-6.456915928944397, 106.98167949914934], [-6.456945246088051, 106.98186188936235], [-6.457293053890149, 106.98180690407754], [-6.4572584063803395, 106.981617808342], [-6.456915928944397, 106.98167949914934]
  // ] //No Bid A1
  // const polyline6 = [
  //   [-6.4572584063803395, 106.981617808342], [-6.457293053890149, 106.98180690407754], [-6.45764619183551, 106.9817626476288], [-6.457611544349884, 106.98156148195268], [-6.4572584063803395, 106.981617808342]
  // ] //No Bid A21
  // const polyline7 = [
  //   [-6.456949243880241, 106.98185920715333], [-6.456975895827351, 106.98204964399339], [-6.457322371011959, 106.98200404644014], [-6.457295719083106, 106.98180422186854], [-6.456949243880241, 106.98185920715333]
  // ] //No Bid A2
  // const polyline8 = [
  //   [-6.457298384276062, 106.98180422186854], [-6.457325036204776, 106.98200404644014], [-6.457684837105143, 106.98196381330493], [-6.457650189622164, 106.9817639887333], [-6.457298384276062, 106.98180422186854]
  // ] //No Bid A20
  // const polyline9 = [
  //   [-6.456974979671768, 106.98204964399339], [-6.457006545564767, 106.9822333753109], [-6.457352104573526, 106.98218643665315], [-6.457325036204776, 106.98200270533562], [-6.456974979671768, 106.98204964399339]
  // ] //No Bid A3
  // const polyline10 = [
  //   [-6.457325036204776, 106.98200270533562], [-6.457352104573526, 106.98218643665315], [-6.457702577286899, 106.98213681578639], [-6.457686586141766, 106.98196515440941], [-6.457325036204776, 106.98200270533562]
  // ] //No Bid A19
  // const polyline11 = [
  //   [-6.457011688545032, 106.98223739862443], [-6.457082191274278, 106.98266789317134], [-6.457407344847653, 106.98261693120004], [-6.457351500752777, 106.98218509554866], [-6.457011688545032, 106.98223739862443]
  // ] //No Bid A4
  // const polyline12 = [
  //   [-6.457382025519521, 106.98241442441942], [-6.457408677443833, 106.98261559009553], [-6.457764480499048, 106.98257803916933], [-6.457739161188777, 106.9823741912842], [-6.457382025519521, 106.98241442441942]
  // ] //No Bid A17
  // const polyline13 = [
  //   [-6.457078193483144, 106.98266655206682], [-6.457111508408314, 106.98281139135362], [-6.457432664174526, 106.98276847600938], [-6.457411342636191, 106.98261693120004], [-6.457078193483144, 106.98266655206682]
  // ] //No Bid A5
  // const polyline14 = [
  //   [-6.457411342636191, 106.98261693120004], [-6.457429998982282, 106.9827711582184], [-6.45779513018873, 106.98272287845613], [-6.457763147903797, 106.98257803916933], [-6.457411342636191, 106.98261693120004]
  // ] //No Bid A16
  // const polyline15 = [
  //   [-6.457108843214391, 106.98281407356264], [-6.457135495153079, 106.98296427726747], [-6.457459316096166, 106.98291331529619], [-6.457431331578397, 106.9827724993229], [-6.457108843214391, 106.98281407356264]
  // ] //No Bid A6
  // const polyline16 = [
  //   [-6.457429998982282, 106.9827711582184], [-6.457459316096166, 106.98291331529619], [-6.457816451710896, 106.98286771774293], [-6.457793797593569, 106.98272556066516], [-6.457429998982282, 106.9827711582184]
  // ] //No Bid A15
  // const polyline17 = [
  //   [-6.457135495153079, 106.98296427726747], [-6.457172807864903, 106.9831493496895], [-6.457485968016419, 106.98310241103175], [-6.457463313884297, 106.98291465640071], [-6.457135495153079, 106.98296427726747]
  // ] //No Bid A7
  // const polyline18 = [
  //   [-6.457464646480337, 106.98291465640071], [-6.4575060818916405, 106.98326468467714], [-6.457876543423037, 106.98321104049684], [-6.457817784306005, 106.98286771774293], [-6.457464646480337, 106.98291465640071]
  // ] //No Bid A14
  // const polyline19 = [
  //   [-6.4573515007405, 106.98218509554866], [-6.4573793603270095, 106.98241308331491], [-6.457736495998149, 106.9823741912842], [-6.457705971270959, 106.98213413357736], [-6.4573515007405, 106.98218509554866]
  // ] //No Bid A18
  // const polyline20 = [
  //   [-6.457172807864903, 106.9831493496895], [-6.457192796816536, 106.9833129644394], [-6.457504624359762, 106.98326200246812], [-6.457488633208371, 106.98310375213624], [-6.457172807864903, 106.9831493496895]
  // ] //No Bid A8
  // const polyline21 = [
  //   [-6.457191589166451, 106.98331564664842], [-6.457215575889155, 106.9834940135479], [-6.45753806422287, 106.98344573378566], [-6.4575114122859505, 106.98326602578165], [-6.457191589166451, 106.98331564664842]
  // ] //No Bid A9
  // const polyline22 = [
  //   [-6.457215309388226, 106.98349535465242], [-6.457287536107634, 106.98399290442467], [-6.457617753463147, 106.98393523693086], [-6.457540462904059, 106.98344975709917], [-6.457215309388226, 106.98349535465242]
  // ] //No Bid A26
  // const polyline23 = [
  //   [-6.457512744871214, 106.98326736688615], [-6.457540729384479, 106.98344573378566], [-6.457893867157072, 106.98339208960536], [-6.457873878233134, 106.98321104049684], [-6.457512744871214, 106.98326736688615]
  // ] //No Bid A13
  // const polyline24 = [
  //   [-6.457539396788643, 106.98344975709917], [-6.457566048704673, 106.98358789086343], [-6.457921851649268, 106.98352351784708], [-6.457893867157072, 106.98339208960536], [-6.457539396788643, 106.98344975709917]
  // ] //No Bid A12
  // const polyline25 = [
  //   [-6.457566048704673, 106.98358789086343], [-6.457590035427899, 106.98375284671785], [-6.457936510192191, 106.98368176817894], [-6.457921851649268, 106.98352083563807], [-6.457566048704673, 106.98358789086343]
  // ] //No Bid A11
  // const polyline26 = [
  //   [-6.457591368023607, 106.98375150561333], [-6.4576180199475495, 106.98393523693086], [-6.457960496908508, 106.98386952280998], [-6.457937842786983, 106.98368176817894], [-6.457591368023607, 106.98375150561333]
  // ] //No Bid A10
  // const polyline27 = [
  //   [-6.457650064696414, 106.98116183280946], [-6.457685357655333, 106.98142603039743], [-6.458029167165283, 106.98137909173967], [-6.457995852300506, 106.98110550642015], [-6.457650064696414, 106.98116183280946]
  // ] //No Bid C1
  // const polyline28 = [
  //   [-6.457685357655333, 106.98142603039743], [-6.457721337731272, 106.98164597153665], [-6.45805448646105, 106.98160439729692], [-6.458029167165283, 106.98137909173967], [-6.457685357655333, 106.98142603039743]
  // ] //No Bid C2
  // const polyline29 = [
  //   [-6.457995852300506, 106.98110550642015], [-6.458029167165283, 106.98137909173967], [-6.45841295424939, 106.98132410645486], [-6.458372976441705, 106.98104381561281], [-6.457995852300506, 106.98110550642015]
  // ] //No Bid C8
  // const polyline30 = [
  //   [-6.458029167165283, 106.98137909173967], [-6.45805448646105, 106.98160439729692], [-6.458446269086712, 106.98155075311662], [-6.45841295424939, 106.98132410645486], [-6.458029167165283, 106.98137909173967]
  // ] //No Bid C7
  // const polyline31 = [
  //   [-6.457718672540541, 106.98164597153665], [-6.457761315590418, 106.98187932372093], [-6.4580851361331755, 106.98184043169024], [-6.458059816838948, 106.98160171508789], [-6.457718672540541, 106.98164597153665]
  // ] //No Bid C3
  // const polyline32 = [
  //   [-6.457761315590418, 106.98187932372093], [-6.457787967494756, 106.9821059703827], [-6.458109122831809, 106.98206171393397], [-6.458083803538765, 106.98184043169024], [-6.457761315590418, 106.98187932372093]
  // ] //No Bid C4
  // const polyline33 = [
  //   [-6.458059816838948, 106.98160171508789], [-6.4580851361331755, 106.98184043169024], [-6.458466257988055, 106.98179215192796], [-6.4584449364932555, 106.9815480709076], [-6.458059816838948, 106.98160171508789]
  // ] //No Bid C6
  // const polyline34 = [
  //   [-6.4580851361331755, 106.98183909058572], [-6.458109122831809, 106.98206171393397], [-6.4585022380084744, 106.98201209306718], [-6.458466257988055, 106.98179081082345], [-6.4580851361331755, 106.98183909058572]
  // ] //No Bid C5
  // const polyline35 = [
  //   [-6.457148321382838, 106.9841229915619], [-6.4571882993075675, 106.9843563437462], [-6.457581415179043, 106.9843026995659], [-6.457557428455411, 106.98403447866443], [-6.457148321382838, 106.9841229915619]
  // ] //No Bid B2
  // const polyline36 = [
  //   [-6.457557428455411, 106.98403447866443], [-6.457581415179043, 106.9843026995659], [-6.458023836787067, 106.98422625660898], [-6.457973198191207, 106.98395401239397], [-6.457557428455411, 106.98403447866443]
  // ] //No Bid B1
  // const polyline37 = [
  //   [-6.457189631904332, 106.9843563437462], [-6.457240270578573, 106.98472112417222], [-6.457573419604627, 106.98464065790179], [-6.457553430668018, 106.98431074619295], [-6.457189631904332, 106.9843563437462]
  // ] //No Bid B3
  // const polyline38 = [
  //   [-6.457554763263828, 106.98430672287942], [-6.457573419604627, 106.98463931679727], [-6.457837273493775, 106.98459908366206], [-6.457790632685117, 106.98426514863971], [-6.457554763263828, 106.98430672287942]
  // ] //No Bid B4
  // const polyline39 = [
  //   [-6.457790632685117, 106.98426514863971], [-6.457837273493775, 106.98459908366206], [-6.458078473161134, 106.98455885052682], [-6.458023836787067, 106.98422759771348], [-6.457790632685117, 106.98426514863971]
  // ] //No Bid B5
  // const polyline40 = [
  //   [-6.457064367773313, 106.98405995965005], [-6.457096350122722, 106.98434025049211], [-6.456944434021261, 106.98436707258226], [-6.456916449475033, 106.98407471179964], [-6.457064367773313, 106.98405995965005]
  // ] //No Bid B6
  // const polyline41 = [
  //   [-6.456916449475033, 106.98407471179964], [-6.456944434021261, 106.98436707258226], [-6.456817837252168, 106.98438718914987], [-6.456785854905506, 106.98409348726274], [-6.456916449475033, 106.98407471179964]
  // ] //No Bid B7
  // const polyline42 = [
  //   [-6.456785854905506, 106.98409348726274], [-6.456817837252168, 106.98438718914987], [-6.456695238245621, 106.98440462350847], [-6.456652595126282, 106.98411360383035], [-6.456785854905506, 106.98409348726274]
  // ] //No Bid B8
  // const polyline43 = [
  //   [-6.457096350122722, 106.98434025049211], [-6.457150986596887, 106.98472514748575], [-6.456995072740373, 106.98474526405334], [-6.456945766639004, 106.98436573147775], [-6.457096350122722, 106.98434025049211]
  // ] //No Bid B9
  // const polyline44 = [
  //   [-6.456945766639004, 106.98436573147775], [-6.45699507272003, 106.98474392294884], [-6.4568658107684005, 106.98475867509843], [-6.456819169849912, 106.98438584804536], [-6.456945766639004, 106.98436573147775]
  // ] //No Bid B10
  // const polyline45 = [
  //   [-6.456819169849912, 106.98438584804536], [-6.4568658107684005, 106.9847546517849], [-6.456740546597917, 106.98477342724802], [-6.456695238265952, 106.98440328240396], [-6.456819169849912, 106.98438584804536]
  // ] //No Bid B11
  // const polyline46 = [
  //   [-6.456652595126282, 106.98411360383035], [-6.456685910079453, 106.98438316583635], [-6.456442044551157, 106.98458835482597], [-6.45632877366718, 106.98420345783235], [-6.456652595126282, 106.98411360383035]
  // ] //No Bid B12
  // const polyline47 = [
  //   [-6.45632877366718, 106.98420345783235], [-6.456442044551157, 106.98458835482597], [-6.456139103142875, 106.98472782969478], [-6.456072473162362, 106.98448777198793], [-6.456089796958137, 106.98447436094285], [-6.4559618673753665, 106.98432818055154], [-6.456085799159167, 106.98421284556389], [-6.45613244014521, 106.98428660631183], [-6.45632877366718, 106.98420345783235]
  // ] //No Bid B13
  // const polyline48 = [
  //   [-6.458090907896036, 106.98464870452882], [-6.458157537610883, 106.9850054383278], [-6.457613397490706, 106.98513284325601], [-6.4575667566410955, 106.98474794626237], [-6.458090907896036, 106.98464870452882]
  // ] //No Bid F1
  // const polyline49 = [
  //   [-6.4575667566410955, 106.98474794626237], [-6.457613397490706, 106.98513284325601], [-6.4573095655982815, 106.98521465063097], [-6.457253596544641, 106.9848257303238], [-6.4575667566410955, 106.98474794626237]
  // ] //No Bid F2
  // const polyline50 = [
  //   [-6.457473474934064, 106.98516905307771], [-6.457524113579922, 106.98552310466768], [-6.457364202049432, 106.98556065559389], [-6.457316228580438, 106.98521733283998], [-6.457473474934064, 106.98516905307771]
  // ] //No Bid F3
  // const polyline51 = [
  //   [-6.457600071539193, 106.98513552546501], [-6.457642714599056, 106.98550298810007], [-6.457521448367818, 106.98552176356316], [-6.45747747270175, 106.98517039418222], [-6.457600071539193, 106.98513552546501]
  // ] //No Bid F4
  // const polyline52 = [
  //   [-6.457599630112807, 106.98513418436052], [-6.457643605768277, 106.98550030589104], [-6.458003406442215, 106.98544800281526], [-6.4579407744914405, 106.98505505919456], [-6.457599630112807, 106.98513418436052]
  // ] //No Bid F5
  // const polyline53 = [
  //   [-6.4579407744914405, 106.98505505919456], [-6.458003406442215, 106.98544800281526], [-6.458071368763025, 106.98543459177019], [-6.458074033951885, 106.98539435863496], [-6.458137998480442, 106.98530852794647], [-6.458207293377254, 106.98528975248338], [-6.458159319988167, 106.9850040972233], [-6.4579407744914405, 106.98505505919456]
  // ] //No Bid F6
  // const polyline54 = [
  //   [-6.4571910477883865, 106.98484987020494], [-6.457246492134955, 106.98522672057155], [-6.457051932992853, 106.9852401316166], [-6.456986635729774, 106.98487803339958], [-6.4571910477883865, 106.98484987020494]
  // ] //No Bid F7
  // const polyline55 = [
  //   [-6.456986635729774, 106.98487803339958], [-6.457051932992853, 106.9852401316166], [-6.456824058834083, 106.98526829481126], [-6.456748100758365, 106.98491290211679], [-6.456986635729774, 106.98487803339958]
  // ] //No Bid F8
  // const polyline56 = [
  //   [-6.457051932992853, 106.9852401316166], [-6.457090578307853, 106.9855982065201], [-6.456897351703358, 106.98562636971475], [-6.456824058834083, 106.98526829481126], [-6.457051932992853, 106.9852401316166]
  // ] //No Bid F9
  // const polyline57 = [
  //   [-6.457246492134955, 106.98522672057155], [-6.457302461189384, 106.98556870222093], [-6.457090578307853, 106.9855982065201], [-6.457051932992853, 106.9852401316166], [-6.457246492134955, 106.98522672057155]
  // ] //No Bid F10
  // const polyline58 = [
  //   [-6.4577981868298915, 106.98213547468187], [-6.458180641494989, 106.98208183050157], [-6.458216621535726, 106.98228299617769], [-6.457828836517539, 106.98232859373095], [-6.4577981868298915, 106.98213547468187]
  // ] //No Bid D2
  // const polyline59 = [
  //   [-6.458180437399316, 106.98208183050157], [-6.458388322028813, 106.9820684194565], [-6.458397650216661, 106.98223739862443], [-6.458385656841607, 106.98223605751993], [-6.458385656873336, 106.9822669029236], [-6.458215084848823, 106.9822816550732], [-6.458180437399316, 106.98208183050157]
  // ] //No Bid D1
  // const polyline60 = [
  //   [-6.457831501707684, 106.98232725262643], [-6.457864816583275, 106.98255926370622], [-6.457991413090544, 106.98254585266115], [-6.457959430818015, 106.98231250047685], [-6.457831501707684, 106.98232725262643]
  // ] //No Bid D3
  // const polyline61 = [
  //   [-6.457959430818015, 106.98231250047685], [-6.457991413090544, 106.98254317045213], [-6.458132668103371, 106.98252707719806], [-6.458099353245412, 106.98229640722278], [-6.457959430818015, 106.98231250047685]
  // ] //No Bid D4
  // const polyline62 = [
  //   [-6.458099353245412, 106.98229640722278], [-6.458132668103371, 106.98252707719806], [-6.458255266761799, 106.98251366615297], [-6.458216621535726, 106.98228299617769], [-6.458099353245412, 106.98229640722278]
  // ] //No Bid D5
  // const polyline63 = [
  //   [-6.458216621535726, 106.98228299617769], [-6.458255266761799, 106.98251366615297], [-6.4584364995068295, 106.98249757289886], [-6.4584245061654135, 106.98241442441942], [-6.458391191326653, 106.9823782145977], [-6.458384528358644, 106.9822682440281], [-6.458216621535726, 106.98228299617769]
  // ] //No Bid D6
  // const polyline64 = [
  //   [-6.457879475127851, 106.98262900114061], [-6.457906127025968, 106.98285430669786], [-6.458047382062597, 106.98284089565277], [-6.458015399793617, 106.98261961340904], [-6.457879475127851, 106.98262900114061]
  // ] //No Bid D7
  // const polyline65 = [
  //   [-6.458015399793617, 106.98261961340904], [-6.458047382062597, 106.98284089565277], [-6.458180641494989, 106.98282077908517], [-6.458140663668958, 106.98260486125947], [-6.458015399793617, 106.98261961340904]
  // ] //No Bid D8
  // const polyline66 = [
  //   [-6.458140663668958, 106.98260486125947], [-6.458180641494989, 106.98282077908517], [-6.458304572735628, 106.98280736804008], [-6.4582739230767965, 106.98259010910989], [-6.458140663668958, 106.98260486125947]
  // ] //No Bid D9
  // const polyline67 = [
  //   [-6.457906127025968, 106.98285430669786], [-6.457947437465289, 106.9830769300461], [-6.458088692490392, 106.98305279016496], [-6.458047382062597, 106.98284089565277], [-6.457906127025968, 106.98285430669786]
  // ] //No Bid D10
  // const polyline68 = [
  //   [-6.458047382062597, 106.98284089565277], [-6.458088692490392, 106.98305279016496], [-6.458216621535726, 106.98303937911987], [-6.458180641494989, 106.98282077908517], [-6.458047382062597, 106.98284089565277]
  // ] //No Bid D11
  // const polyline69 = [
  //   [-6.458180641494989, 106.98282077908517], [-6.458216621535726, 106.98303937911987], [-6.458340552767548, 106.98302060365678], [-6.4583032401418015, 106.98280736804008], [-6.458180641494989, 106.98282077908517]
  // ] //No Bid D12
  // const polyline70 = [
  //   [-6.458099353245412, 106.98311984539033], [-6.458130002914816, 106.98334649205209], [-6.458283251234022, 106.98333576321603], [-6.458248603791996, 106.98310643434526], [-6.458099353245412, 106.98311984539033]
  // ] //No Bid D13
  // const polyline71 = [
  //   [-6.4579607634127445, 106.98313459753993], [-6.4580313909283555, 106.98355972766876], [-6.458163317770763, 106.98354765772822], [-6.458099353245412, 106.98311984539033], [-6.4579607634127445, 106.98313459753993]
  // ] //No Bid D14
  // const polyline72 = [
  //   [-6.458050047251597, 106.98364019393922], [-6.458088692490392, 106.98386549949647], [-6.458207293377254, 106.98385074734689], [-6.458175311118376, 106.98362812399864], [-6.458050047251597, 106.98364019393922]
  // ] //No Bid D15
  // const polyline73 = [
  //   [-6.458088692490392, 106.98386549949647], [-6.458116676971826, 106.98407471179964], [-6.458231280070099, 106.98405995965005], [-6.458207293377254, 106.98385074734689], [-6.458088692490392, 106.98386549949647]
  // ] //No Bid D16
  // const polyline74 = [
  //   [-6.4582739230767965, 106.98259010910989], [-6.458304572735628, 106.98280736804008], [-6.458617732186951, 106.98278322815897], [-6.458612401814944, 106.98275372385979], [-6.458476477309502, 106.98275506496431], [-6.458479142496225, 106.98260352015498], [-6.458463151375621, 106.98256596922874], [-6.4582739230767965, 106.98259010910989]
  // ] //No Bid D18
  // const polyline75 = [
  //   [-6.4583032401418015, 106.98280736804008], [-6.458340552767548, 106.98302060365678], [-6.458640386267409, 106.98297634720804], [-6.458617732186951, 106.98278322815897], [-6.4583032401418015, 106.98280736804008]
  // ] //No Bid D19
  // const polyline76 = [
  //   [-6.458130002914816, 106.98334649205209], [-6.458163317770763, 106.98354765772822], [-6.458295244578784, 106.98353156447413], [-6.458283251234022, 106.98333576321603], [-6.458130002914816, 106.98334649205209]
  // ] //No Bid D20
  // const polyline77 = [
  //   [-6.458175311118376, 106.98362812399864], [-6.458207293377254, 106.98385074734689], [-6.458301907547976, 106.98383867740633], [-6.458253934167859, 106.98373138904573], [-6.458283251234022, 106.98367372155191], [-6.45830057495415, 106.98361068964006], [-6.458175311118376, 106.98362812399864]
  // ] //No Bid D21
  // const polyline78 = [
  //   [-6.458207293377254, 106.98385074734689], [-6.458231280070099, 106.98405727744102], [-6.458457821001972, 106.98404386639596], [-6.458411180230171, 106.98399022221567], [-6.458363206860409, 106.98394730687143], [-6.458335222392601, 106.98390841484071], [-6.458301907547976, 106.98383599519731], [-6.458207293377254, 106.98385074734689]
  // ] //No Bid D22
  // const polyline79 = [
  //   [-6.458251268979927, 106.98412433266641], [-6.458309903110892, 106.9845025241375], [-6.458461818782215, 106.98447838425638], [-6.458397854294586, 106.98410689830781], [-6.458251268979927, 106.98412433266641]
  // ] //No Bid E1
  // const polyline80 = [
  //   [-6.458128670320532, 106.9841404259205], [-6.458187304465695, 106.98452264070512], [-6.4583085705170795, 106.9844998419285], [-6.458251268979927, 106.98412433266641], [-6.458128670320532, 106.9841404259205]
  // ] //No Bid E2
  // const polyline81 = [
  //   [-6.458188637059814, 106.98452129960062], [-6.458240608228126, 106.98486328125001], [-6.458457821001972, 106.98483377695085], [-6.45840851504308, 106.98448508977891], [-6.458188637059814, 106.98452129960062]
  // ] //No Bid E3
  // const polyline82 = [
  //   [-6.45840851504308, 106.98448508977891], [-6.458457821001972, 106.98483377695085], [-6.458680364053976, 106.98480159044267], [-6.458641718860344, 106.98446094989778], [-6.45840851504308, 106.98448508977891]
  // ] //No Bid E4
  // const polyline83 = [
  //   [-6.458244606010074, 106.98491558432582], [-6.458299242360312, 106.98526695370676], [-6.458327226830092, 106.98527231812479], [-6.458400519481728, 106.98523476719858], [-6.458515122515741, 106.98526158928873], [-6.458465816562433, 106.98489010334016], [-6.458244606010074, 106.98491558432582]
  // ] //No Bid E5
  // const polyline84 = [
  //   [-6.458464483969027, 106.98488742113115], [-6.4585137899224625, 106.98525488376619], [-6.458537776600778, 106.98526695370676], [-6.458588415140164, 106.98526695370676], [-6.458663040346849, 106.98520123958589], [-6.458679031461142, 106.98511809110644], [-6.458707015909931, 106.98507517576219], [-6.4587123462809455, 106.98496654629709], [-6.458699020353286, 106.984860599041], [-6.458464483969027, 106.98488742113115]
  // ] //No Bid E6
  // const polyline85 = [
  //   [-6.458643051453279, 106.98446094989778], [-6.458681696646808, 106.98479890823366], [-6.4589162329304095, 106.98477745056152], [-6.458813623319706, 106.9846111536026], [-6.458785638876808, 106.984501183033], [-6.458758987025, 106.98445022106172], [-6.458643051453279, 106.98446094989778]
  // ] //No Bid E7
  // const polyline86 = [
  //   [-6.458397854294586, 106.98410689830781], [-6.458461818782215, 106.98447704315187], [-6.458754989247111, 106.98445022106172], [-6.458720341837374, 106.98438182473184], [-6.4586776988682955, 106.98432415723802], [-6.458607071442872, 106.98420479893686], [-6.458487138056342, 106.9841229915619], [-6.45847114693598, 106.98410153388978], [-6.458397854294586, 106.98410689830781]
  // ] //No Bid E8
  // const polyline87 = [
  //   [-6.457658264319253, 106.98555126786233], [-6.457687581419918, 106.98578730225564], [-6.457856821013336, 106.98576986789705], [-6.457819508351929, 106.98552578687669], [-6.457658264319253, 106.98555126786233]
  // ] //No Bid G1
  // const polyline88 = [
  //   [-6.457526337345208, 106.98556736111642], [-6.457562317432444, 106.98580205440523], [-6.457687581419918, 106.98578730225564], [-6.457658264319253, 106.98555126786233], [-6.457526337345208, 106.98556736111642]
  // ] //No Bid G2
  // const polyline89 = [
  //   [-6.457375753989399, 106.98560491204263], [-6.457419729664309, 106.98582753539088], [-6.457562317432444, 106.98580205440523], [-6.457526337345208, 106.98556736111642], [-6.457375753989399, 106.98560491204263]
  // ] //No Bid G3
  // const polyline90 = [
  //   [-6.457419729664309, 106.98582753539088], [-6.457469035719522, 106.98605686426164], [-6.45757830858152, 106.98603808879854], [-6.457544993687062, 106.98580473661426], [-6.457419729664309, 106.98582753539088]
  // ] //No Bid G4
  // const polyline91 = [
  //   [-6.457544993687062, 106.98580473661426], [-6.45757830858152, 106.98603808879854], [-6.457680918442648, 106.9860166311264], [-6.4576542665326615, 106.98579132556917], [-6.457539663303744, 106.98580473661426]
  // ] //No Bid G5
  // const polyline92 = [
  //   [-6.4576542665326615, 106.98579266667367], [-6.457682251038115, 106.98601394891742], [-6.457812845376389, 106.98599517345428], [-6.457790191258897, 106.98577657341959], [-6.4576542665326615, 106.98579266667367]
  // ] //No Bid G6
  // const polyline93 = [
  //   [-6.457790191258897, 106.98577657341959], [-6.457811512781278, 106.9859938323498], [-6.458038617203565, 106.98596062697575], [-6.458013297907009, 106.98574605025456], [-6.457790191258897, 106.98577657341959]
  // ] //No Bid G7
  // const polyline94 = [
  //   [-6.458013297907009, 106.98574605025456], [-6.458038617203565, 106.98596062697575], [-6.4582225152142465, 106.98592307604954], [-6.458205191491459, 106.98572593368694], [-6.458013297907009, 106.98574605025456]
  // ] //No Bid G8
  // const polyline95 = [
  //   [-6.457819508351929, 106.98552578687669], [-6.457856821013336, 106.98576986789705], [-6.458051379846097, 106.98574036359788], [-6.458036721306495, 106.98555395007133], [-6.458038053901021, 106.98549628257753], [-6.457819508351929, 106.98552578687669]
  // ] //No Bid G9A
  // const polyline96 = [
  //   [-6.457129223619903, 106.98567062616351], [-6.457173199316225, 106.985941529274], [-6.457361095430243, 106.98591604828836], [-6.4573211175394825, 106.98564782738687], [-6.457129223619903, 106.98567062616351]
  // ] //No Bid G9B
  // const polyline97 = [
  //   [-6.456959983783237, 106.9857068359852], [-6.456995963910726, 106.98596835136415], [-6.457173199316225, 106.985941529274], [-6.457129223619903, 106.98567062616351], [-6.456959983783237, 106.9857068359852]
  // ] //No Bid G10
  // const polyline98 = [
  //   [-6.456766757128896, 106.98599785566331], [-6.456812065454462, 106.98629155755044], [-6.456986635729774, 106.9862647354603], [-6.456949323004236, 106.9859629869461], [-6.456766757128896, 106.98599785566331]
  // ] //No Bid G11
  // const polyline99 = [
  //   [-6.456584191187732, 106.98603272438051], [-6.456626834333164, 106.98630765080453], [-6.456812065454462, 106.98629155755044], [-6.456766757128896, 106.98599785566331], [-6.456584191187732, 106.98603272438051]
  // ] //No Bid G12
  // const polyline100 = [
  //   [-6.456430942354179, 106.98606222867967], [-6.4564735855125255, 106.98632910847665], [-6.456626834333164, 106.98630765080453], [-6.456584191187732, 106.98603272438051], [-6.456430942354179, 106.98606222867967]
  // ] //No Bid G13
  // const polyline101 = [
  //   [-6.456256371887269, 106.98606491088869], [-6.456333662635767, 106.98635861277583], [-6.4564735855125255, 106.98632642626762], [-6.456422946761582, 106.98600187897684], [-6.456256371887269, 106.98606491088869]
  // ] //No Bid G14
  // const polyline102 = [
  //   [-6.456356316818434, 106.98643103241922], [-6.456533552447856, 106.98690980672839], [-6.456486911498771, 106.98640018701555], [-6.456356316818434, 106.98643103241922]
  // ] //No Bid G15A
  // const polyline103 = [
  //   [-6.456486911498771, 106.98640018701555], [-6.456513563470206, 106.98668047785759], [-6.456638827717175, 106.98667243123056], [-6.456610843154052, 106.98638275265695], [-6.456486911498771, 106.98640018701555]
  // ] //No Bid G15B
  // const polyline104 = [
  //   [-6.456513563470206, 106.98668047785759], [-6.456533552447856, 106.98690980672839], [-6.456657484091726, 106.98690578341484], [-6.456638827717175, 106.98667243123056], [-6.456513563470206, 106.98668047785759]
  // ] //No Bid G15C
  // const polyline105 = [
  //   [-6.456610843154052, 106.98638275265695], [-6.456657484091726, 106.98690578341484], [-6.456756096345823, 106.98688700795175], [-6.456721448799284, 106.98636800050738], [-6.456610843154052, 106.98638275265695]
  // ] //No Bid G15D
  // const polyline106 = [
  //   [-6.456721448799284, 106.98636800050738], [-6.456756096345823, 106.98688700795175], [-6.4567987394767785, 106.98686286807063], [-6.457031944035659, 106.98643639683725], [-6.457018618063764, 106.98633715510371], [-6.456721448799284, 106.98636800050738]
  // ] //No Bid G16
  // const polyline107 = [
  //   [-6.456997296507987, 106.98596701025966], [-6.4570359418271615, 106.9863183796406], [-6.457101239083879, 106.98631167411806], [-6.457090578307853, 106.98621243238452], [-6.457118562844464, 106.98617085814479], [-6.457154542960682, 106.98615208268167], [-6.457243826941744, 106.98611989617349], [-6.457297130803509, 106.98613598942758], [-6.457403738510234, 106.98613062500955], [-6.457361095430243, 106.98591738939287], [-6.456997296507987, 106.98596701025966]
  // ] //No Bid G17
  // const polyline108 = [
  //   [-6.457501581326171, 106.98610144294902], [-6.457546889585976, 106.9862932208936], [-6.457624180137444, 106.98629992641612], [-6.457601526011517, 106.98608669079944], [-6.457501581326171, 106.98610144294902]
  // ] //No Bid G18A
  // const polyline109 = [
  //   [-6.457601526011517, 106.98608669079944], [-6.457624180137444, 106.98629992641612], [-6.45772279220324, 106.98631601967021], [-6.457692142509169, 106.98607327975438], [-6.457601526011517, 106.98608669079944]
  // ] //No Bid G18B
  // const polyline110 = [
  //   [-6.457692142509169, 106.98607327975438], [-6.45772279220324, 106.98631601967021], [-6.457853386531069, 106.98632138408824], [-6.457832065010456, 106.98605584539577], [-6.457692142509169, 106.98607327975438]
  // ] //No Bid G18C
  // const polyline111 = [
  //   [-6.457832065010456, 106.98605584539577], [-6.457853386531069, 106.98632138408824], [-6.457922681466837, 106.98630126752063], [-6.4580372846090395, 106.98621141351863], [-6.4580372846090395, 106.98603438772365], [-6.457832065010456, 106.98605584539577]
  // ] //No Bid G18D
  // const polyline177 = [
  //   [-6.458039182425738, 106.98549628257753], [-6.458036517236687, 106.98555260896684], [-6.458053840965251, 106.98574036359788], [-6.45827771678877, 106.98571756482126], [-6.458145789976183, 106.98561295866969], [-6.458039182425738, 106.98549628257753]
  // ] //No Bid G19
  // const polyline178 = [
  //   [-6.456658612619521, 106.98690444231035], [-6.45670658615083, 106.98703184723855], [-6.456651949628714, 106.98708951473238], [-6.456661277815824, 106.98718070983887], [-6.4567678856564505, 106.98710426688194], [-6.456773216047898, 106.98698356747629], [-6.456757224873403, 106.98688834905627], [-6.456658612619521, 106.98690444231035]
  // ] //No Bid G15E
  // const polyline176 = [
  //   [-6.458568222133073, 106.98204293847085], [-6.458594874043696, 106.98216363787654], [-6.458576217739041, 106.98218643665315], [-6.458396317622962, 106.98223471641542], [-6.458384324247985, 106.9820684194565], [-6.458568222133073, 106.98204293847085]
  // ] //No Bid D17
  // const polyline174 = [
  //   [-6.458422969496055, 106.98103979229928], [-6.458653508139611, 106.98100224137308], [-6.4586628362906024, 106.98117256164552], [-6.4586881555567395, 106.98119804263118], [-6.4587028140786575, 106.98128253221513], [-6.458482936205362, 106.98131874203683], [-6.458422969496055, 106.98103979229928]
  // ] //No Bid C9
  // const polyline175 = [
  //   [-6.458485601392263, 106.98132008314136], [-6.458704146671542, 106.9812798500061], [-6.458718805192989, 106.98139250278474], [-6.458642847395392, 106.9814206659794], [-6.4586588385116315, 106.9816727936268], [-6.458642847395392, 106.98169559240343], [-6.458668166662534, 106.98180019855499], [-6.458633519244032, 106.9818162918091], [-6.4586388496162686, 106.98194235563281], [-6.458580215518649, 106.9819611310959], [-6.458485601392263, 106.98132008314136]
  // ] //No Bid C10 Batas Upakara
  // const polyline114 = [
  //   [-6.455312994703622, 106.98178609099368], [-6.454975846362161, 106.98188668789697], [-6.455027817860258, 106.9821066597922], [-6.454568069807351, 106.98224883674884], [-6.454677343295422, 106.9826029378484], [-6.454735977840279, 106.98249026931671], [-6.454746638665882, 106.98244198280314], [-6.45486913420541, 106.98230195148821], [-6.455027713921462, 106.98210746414182], [-6.455089013630332, 106.98204844729189], [-6.455282240924932, 106.98200405975521], [-6.455304895154634, 106.98201613138363], [-6.455457455823745, 106.98210999369621], [-6.455489438254322, 106.98209658265115], [-6.455504096867674, 106.9816365838051], [-6.455441464607699, 106.98175057768825], [-6.455312994703622, 106.98178609099368]
  // ] //No Bid 23
  // const polyline115 = [
  //   [-6.454677343295422, 106.9826029378484], [-6.454735977840279, 106.98249026931671], [-6.454746638665882, 106.98244198280314], [-6.45486913420541, 106.98230195148821], [-6.455027713921462, 106.98210746414182], [-6.455089013630332, 106.98204844729189], [-6.455282240924932, 106.98200405975521], [-6.455304895154634, 106.98201613138363], [-6.455458144329001, 106.98211269597161], [-6.455488794158311, 106.98209525917505], [-6.455664697490639, 106.98219329276743], [-6.455588739240997, 106.98241594724666], [-6.455464807335534, 106.98269895986795], [-6.455358199220552, 106.98284516070075], [-6.455364862228395, 106.98299672670169], [-6.455294234340785, 106.98302757641866], [-6.455200952209976, 106.98303696546297], [-6.45480383666084, 106.98275797671788], [-6.454677343295422, 106.9826029378484]
  // ] //No Bid 24
  // const polyline118 = [
  //   [-6.456108453352929, 106.98273378526423], [-6.455913893773488, 106.9827968259903], [-6.455932550174768, 106.98282901699933], [-6.455873915768455, 106.98286254930044], [-6.45596319997535, 106.98306907395603], [-6.456212396111307, 106.98295640542432], [-6.456108453352929, 106.98273378526423]
  // ] //No Bid 36
  // const polyline119 = [
  //   [-6.455964532575333, 106.9830676987199], [-6.456212396111307, 106.98295640542432], [-6.456313673650215, 106.98319512146406], [-6.456081801360159, 106.9833118138719], [-6.455964532575333, 106.9830676987199]
  // ] //No Bid 37
  // const polyline120 = [
  //   [-6.456313673650215, 106.98319512146406], [-6.456313673650215, 106.98319242031388], [-6.456520226462845, 106.98378525526913], [-6.45646292472327, 106.9837973268975], [-6.456435073418429, 106.98381185531618], [-6.456415484200256, 106.98386952280998], [-6.45640389059468, 106.98392987251283], [-6.4563700425915105, 106.98396742343904], [-6.456338859763741, 106.98397010564805], [-6.456084466559502, 106.98331177917763], [-6.456313673650215, 106.98319512146406]
  // ] //No Bid 38
  // const polyline134 = [
  //   [-6.454587954922932, 106.98240773727547], [-6.4548398169415435, 106.9832715293517], [-6.454429375069175, 106.98344589731738], [-6.4539096592340695, 106.98285975269424], [-6.454425377257088, 106.98268672602056], [-6.454557305039096, 106.9825713749048], [-6.454591952733721, 106.98246004766517], [-6.454587954922932, 106.98240773727547]
  // ] //No Bid 22
  // const polyline135 = [
  //   [-6.45389633317999, 106.98284771088413], [-6.4539563004205265, 106.98291075161016], [-6.454229484426477, 106.98321921727414], [-6.453984285130362, 106.98336282704061], [-6.453709768386251, 106.9829536431373], [-6.45389633317999, 106.98284771088413]
  // ] //No Bid 16
  // const polyline136 = [
  //   [-6.453709768386251, 106.9829537462823], [-6.453982952525163, 106.9833640846914], [-6.453724427051103, 106.98355191865035], [-6.453491220969029, 106.98309051418728], [-6.453709768386251, 106.9829537462823]
  // ] //No Bid 15
  // const polyline137 = [
  //   [-6.453493886182011, 106.98309319677135], [-6.453724427051103, 106.98355191865035], [-6.4535032144272995, 106.98368336527065], [-6.45329132995609, 106.98320586530305], [-6.453493886182011, 106.98309319677135]
  // ] //No Bid 13
  // const polyline138 = [
  //   [-6.453505879640217, 106.98368205454703], [-6.453739085715523, 106.98354121888245], [-6.453832368115598, 106.98373436493674], [-6.453583170808496, 106.98385105734455], [-6.453505879640217, 106.98368205454703],
  // ] //No Bid 14
  // const polyline139 = [
  //   [-6.453739085715523, 106.9835398775904], [-6.453984285130362, 106.98336139423078], [-6.454229484426477, 106.98322065008398], [-6.4544307076731915, 106.9834445543375], [-6.453832368115598, 106.98373436493674], [-6.453739085715523, 106.9835398775904]
  // ] //No Bid 17
  // const polyline140 = [
  //   [-6.454298779858208, 106.98350893635562], [-6.4537817291005535, 106.98375698892946], [-6.453989615551095, 106.984293505747], [-6.454515994323181, 106.98408971581058], [-6.454298779858208, 106.98350893635562]
  // ] //No Bid 18
  // const polyline141 = [
  //   [-6.453901663601664, 106.98440357814889], [-6.454535983379697, 106.98412861327986], [-6.454697872503733, 106.98467418551448], [-6.454626600425994, 106.9846985907596], [-6.4544173816328385, 106.98481528316742], [-6.454290784231961, 106.98473882952094], [-6.4543161037146675, 106.9846771300869], [-6.454290784231961, 106.98466505845852], [-6.4542627995390704, 106.98469054300735], [-6.454113547817565, 106.98475224244135], [-6.454074902275358, 106.98487698260143], [-6.454024263284563, 106.98496684916837], [-6.453940309157078, 106.98498965113313], [-6.453901663601664, 106.98440357814889]
  // ] //No Bid 19
  // const polyline142 = [
  //   [-6.453769735648874, 106.98376235409762], [-6.453974956893916, 106.98429887091514], [-6.453591166445927, 106.98447061687105], [-6.4533672885503135, 106.98395281756785], [-6.453769735648874, 106.98376235409762]
  // ] //No Bid 11
  // const polyline143 = [
  //   [-6.453292662563109, 106.98320571789944], [-6.453584503414739, 106.98384953808049], [-6.4533672885503135, 106.9839514762758], [-6.453066119320345, 106.98331704513906], [-6.453292662563109, 106.98320571789944]
  // ] //No Bid 12
  // const polyline144 = [
  //   [-6.453066119320345, 106.98331704513906], [-6.453473897084364, 106.98419558242603], [-6.453242023494109, 106.98430697924168], [-6.452838243368074, 106.98343641112923], [-6.453066119320345, 106.98331704513906]
  // ] //No Bid 10
  // const polyline145 = [
  //   [-6.453473897084364, 106.98419296941793], [-6.453591166445927, 106.98447061687105], [-6.453282001706896, 106.98461681770381], [-6.453175393132452, 106.98441025872904], [-6.453244688708389, 106.98437940901206], [-6.453215371350492, 106.98432039216213], [-6.453473897084364, 106.98419296941793]
  // ] //No Bid 8
  // const polyline146 = [
  //   [-6.4538243724819715, 106.98436599609161], [-6.4539109918394475, 106.9847120494389], [-6.453567179533267, 106.98486629802396], [-6.45341259718003, 106.98455511826981], [-6.4538243724819715, 106.98436599609161]
  // ] //No Bid 7
  // const polyline147 = [
  //   [-6.45341259718003, 106.98455511826981], [-6.453567179533267, 106.98486629802396], [-6.453429921066781, 106.98491458453756], [-6.453284666920971, 106.98461681770381], [-6.45341259718003, 106.98455511826981]
  // ] //No Bid 6
  // const polyline148 = [
  //   [-6.453906994023276, 106.98471199655366], [-6.453924317893133, 106.98496952462605], [-6.453552520863861, 106.98515596422016], [-6.453429921066781, 106.98491458453756], [-6.453567179533267, 106.98486222126255], [-6.453906994023276, 106.98471199655366]
  // ] //No Bid 5
  // const polyline151 = [
  //   [-6.453103432332007, 106.98563078160369], [-6.453372618977536, 106.98552616082429], [-6.453397938506145, 106.98559054284236], [-6.453395273292667, 106.9856280990196], [-6.453132749696379, 106.98573942625924], [-6.453103432332007, 106.98563078160369]
  // ] //No Bid 3
  // const polyline152 = [
  //   [-6.453132749696379, 106.98573942625924], [-6.453392608079177, 106.98563078160369], [-6.453463236231968, 106.985671020365], [-6.4535205383109595, 106.98596073944645], [-6.453483225330035, 106.98595000911013], [-6.45342592324682, 106.98595000911013], [-6.453363290729843, 106.98598085882713], [-6.453304656026073, 106.98605194730544], [-6.453222034386527, 106.98608547960653], [-6.453132749696379, 106.98573942625924]
  // ] //No Bid 2
  // const polyline155 = [
  //   [-6.4528395759762756, 106.98343633461437], [-6.45324069088695, 106.98430817444284], [-6.453018145444176, 106.98440206488594], [-6.452635686879986, 106.98354766185403], [-6.4528395759762756, 106.98343633461437]
  // ] //No Bid 9
  // const polyline156 = [
  //   [-6.452346510700744, 106.98368847370149], [-6.4524024802967075, 106.98381856083871], [-6.452493097724671, 106.98398083448411], [-6.45259970644271, 106.98420882225038], [-6.452782273820251, 106.9845870137215], [-6.452844906409058, 106.98483377695085], [-6.452883552045104, 106.98490351438524], [-6.452960843308341, 106.98516905307771], [-6.452968838955607, 106.9852736592293], [-6.4530301389136415, 106.98545068502429], [-6.453555186076511, 106.98515295982362], [-6.4531567366296105, 106.98434427380563], [-6.453016812836432, 106.98439925909045], [-6.452637019488722, 106.98354631662372], [-6.452346510700744, 106.98368847370149]
  // ] //No Bid 1
  // const polyline122 = [
  //   [-6.454977474790446, 106.98338270187378], [-6.455057430938902, 106.98366835713388], [-6.455421231254979, 106.98352754116058], [-6.455286238730251, 106.98319897055629], [-6.454977474790446, 106.98338270187378]
  // ] //No Bid 28
  // const polyline123 = [
  //   [-6.455059030078006, 106.98366835713388], [-6.455080351715397, 106.98375016450883], [-6.455193223114301, 106.9840304553509], [-6.4555516929285774, 106.98389500379564], [-6.455422430608449, 106.98352620005608], [-6.455059030078006, 106.98366835713388]
  // ] //No Bid 33
  // const polyline124 = [
  //   [-6.455289703502962, 106.98319628834726], [-6.455442952681922, 106.9835785031319], [-6.455733193157506, 106.98343366384508], [-6.455546495792512, 106.98304474353792], [-6.455289703502962, 106.98319628834726]
  // ] //No Bid 34
  // const polyline125 = [
  //   [-6.455546229276367, 106.98304474353792], [-6.455732793393588, 106.98343232274057], [-6.456001578857549, 106.9832955300808], [-6.455833671244264, 106.98288515210153], [-6.455546229276367, 106.98304474353792]
  // ] //No Bid 35
  // const polyline126 = [
  //   [-6.45573639141111, 106.98393523693086], [-6.455809684437835, 106.98414713144304], [-6.456077137261279, 106.9839768111706], [-6.455991451110519, 106.98375955224039], [-6.45573639141111, 106.98393523693086]
  // ] //No Bid 31
  // const polyline157 = [
  //   [-6.455869917967781, 106.98146224021913], [-6.455900567772167, 106.98165670037271], [-6.455984521574675, 106.98163524270059], [-6.455951206575348, 106.98144614696503], [-6.455869917967781, 106.98146224021913]
  // ] //No Bid 1 Kodam
  // const polyline158 = [
  //   [-6.456776085313907, 106.98130667209627], [-6.456704125025111, 106.98131874203683], [-6.456738772572846, 106.9815091788769], [-6.456814730649962, 106.98149845004085], [-6.456776085313907, 106.98130667209627]
  // ] //No Bid 2 kodam
  // const polyline159 = [
  //   [-6.456814730649962, 106.98149845004085], [-6.4566255017349246, 106.98152661323549], [-6.456650821100893, 106.98169961571695], [-6.456844047799482, 106.98166742920877], [-6.456814730649962, 106.98149845004085]
  // ] //No Bid 3 kodam
  // const polyline160 = [
  //   [-6.45644826613769, 106.98155477643014], [-6.4564735855125255, 106.9817277789116], [-6.45655887181843, 106.98171436786653], [-6.4565375502433024, 106.98154002428056], [-6.45644826613769, 106.98155477643014]
  // ] //No Bid 4 kodam
  // const polyline161 = [
  //   [-6.4562190591079025, 106.9816218316555], [-6.456292352064757, 106.98180690407754], [-6.456365645011002, 106.98219984769823], [-6.4562004027171955, 106.98222398757936], [-6.4561417683419124, 106.98204696178438], [-6.456129774946135, 106.9820335507393], [-6.456128442346584, 106.98200941085817], [-6.456061812364672, 106.98186323046687], [-6.456071140562659, 106.98180958628657], [-6.456027164770602, 106.98172375559807], [-6.456032495169849, 106.9816727936268], [-6.4562190591079025, 106.9816218316555]
  // ] //No Bid 5 kodam
  // const polyline164 = [
  //   [-6.456573530400816, 106.9821770489216], [-6.45673610737695, 106.98214754462245], [-6.456784080900919, 106.98254451155663], [-6.456626834333164, 106.98255792260171], [-6.456573530400816, 106.9821770489216]
  // ] //No Bid 10 kodam
  // const polyline165 = [
  //   [-6.456349653823632, 106.98266655206682], [-6.456649488502716, 106.9826263189316], [-6.4568520433854255, 106.98260352015498], [-6.456864436547449, 106.98274970054628], [-6.456791676704395, 106.98276311159135], [-6.456692931209623, 106.98276847600938], [-6.456698528117405, 106.98280334472658], [-6.456430009539106, 106.98287576436998], [-6.456349653823632, 106.98266655206682]
  // ] //No Bid 13 kodam
  // const polyline166 = [
  //   [-6.456604180162609, 106.9829347729683], [-6.456618838743672, 106.9830434024334], [-6.456638827717175, 106.98310241103175], [-6.456645490708173, 106.98315203189851], [-6.456701459829038, 106.98329821228982], [-6.456704125025111, 106.98333442211153], [-6.456748100758365, 106.98345914483072], [-6.456753431150016, 106.9834913313389], [-6.4567987394767785, 106.98362544178964], [-6.456840716305306, 106.98377564549448], [-6.456986902245168, 106.98375552892688], [-6.457014886787503, 106.98372200131418], [-6.456997296507987, 106.98356240987779], [-6.456983970535177, 106.98355436325075], [-6.45697197715936, 106.98342561721803], [-6.4569573185885, 106.98340684175493], [-6.456928001445545, 106.98326334357262], [-6.456921338458274, 106.98324590921405], [-6.456894686508302, 106.98307156562807], [-6.456892021313221, 106.98305547237398], [-6.456860038971241, 106.98288381099702], [-6.456604180162609, 106.9829347729683]
  // ] //No Bid 14
  // const polyline167 = [
  //   [-6.456295017262994, 106.98181092739105], [-6.456849378190128, 106.98171973228456], [-6.456912010275936, 106.98207512497903], [-6.456360314615267, 106.98217168450357], [-6.456295017262994, 106.98181092739105]
  // ] //No Bid kadus
  // const polyline168 = [
  //   [-6.456365645011002, 106.98219984769823], [-6.456401625180742, 106.98239028453828], [-6.4566015149660005, 106.98236480355264], [-6.456573530400816, 106.9821783900261], [-6.456365645011002, 106.98219984769823]
  // ] //No Bid 8 kodam
  // const polyline169 = [
  //   [-6.456401625180742, 106.98239028453828], [-6.456422946761582, 106.98258474469186], [-6.456629499529646, 106.9825565814972], [-6.4566015149660005, 106.98236480355264], [-6.456401625180742, 106.98239028453828]
  // ] //No Bid 9 kodam
  // const polyline170 = [
  //   [-6.456760094139501, 106.98233127593994], [-6.456784080900919, 106.98254182934762], [-6.456975974951333, 106.98252707719806], [-6.456951988198998, 106.98234334588052], [-6.456760094139501, 106.98233127593994]
  // ] //No Bid 12 kodam
  // const polyline171 = [
  //   [-6.456737439974899, 106.98215022683145], [-6.456760094139501, 106.98233127593994], [-6.456951988198998, 106.98234334588052], [-6.456914675470903, 106.98213011026385], [-6.456737439974899, 106.98215022683145]
  // ] //No Bid 11
  // const polyline173 = [
  //   [-6.45653621764482, 106.98154002428056], [-6.456560204416848, 106.98171168565752], [-6.456656151493574, 106.98169961571695], [-6.456626834333164, 106.98152527213097], [-6.45653621764482, 106.98154002428056]
  // ] //No Bid antara 4 dan 3
  // const polyline180 = [
  //   [-6.456696262704778, 106.98276847600938], [-6.456700793530019, 106.98280066251756], [-6.456595118490028, 106.98283016681671], [-6.456607911441885, 106.9829347729683], [-6.456861105053401, 106.98288246989253], [-6.4568661689284115, 106.98274970054628], [-6.456798472961283, 106.98276177048685], [-6.456696262704778, 106.98276847600938]
  // ] //No Bid 15 kodam
  // const polyline181 = [
  //   [-6.456865369361709, 106.98275372385979], [-6.4568636369807475, 106.98288381099702], [-6.456884558758803, 106.98301926255228], [-6.4570508669110875, 106.9830071926117], [-6.45702234934, 106.98273763060573], [-6.456865369361709, 106.98275372385979]
  // ] //No Bid 16 kodam
  // const polyline182 = [
  //   [-6.456886690923033, 106.98302060365678], [-6.45691574153263, 106.98320701718332], [-6.457084181858393, 106.98317617177965], [-6.4570511334264555, 106.98300585150719], [-6.456886690923033, 106.98302060365678]
  // ] //No Bid 17 kodam
  // const polyline183 = [
  //   [-6.456915874800504, 106.98320969939232], [-6.456922537787851, 106.98324859142305], [-6.456959450752424, 106.98340281844142], [-6.45697370951961, 106.98342427611354], [-6.457122560635279, 106.98339477181436], [-6.4570852479197525, 106.98317617177965], [-6.456915874800504, 106.98320969939232]
  // ] //No Bid 18 kodam
  // const polyline184 = [
  //   [-6.456596584356308, 106.98283284902574], [-6.456434007335366, 106.98287442326547], [-6.456352319021564, 106.98267191648486], [-6.456379903815247, 106.98279529809953], [-6.456342191261225, 106.98282212018968], [-6.456228520571055, 106.98284760117532], [-6.456236516166718, 106.9829508662224], [-6.456312474319188, 106.9830434024334], [-6.456372441273615, 106.98316410183908], [-6.456528355321879, 106.98352620005608], [-6.456622969806395, 106.98382660746574], [-6.456840183274366, 106.98377564549448], [-6.456754497232418, 106.98348730802537], [-6.45674876705732, 106.98346048593523], [-6.456703458726093, 106.983330398798], [-6.456703058962951, 106.9832955300808], [-6.456647356337493, 106.98315337300302], [-6.456640027047426, 106.98310375213624], [-6.456620970909008, 106.98303937911987], [-6.456591920241844, 106.98283284902574], [-6.456596584356308, 106.98283284902574]
  // ] //No Bid 19 kodam
  // const polyline179 = [
  //   [-6.45699529761209, 106.98258340358736], [-6.456854042281883, 106.98260620236398], [-6.456864303279549, 106.98275506496431], [-6.4570224825875195, 106.98273763060573], [-6.45699529761209, 106.98258340358736]
  // ] //No Bid kodam 20
  // const polyline185 = [
  //   [-6.456975441920532, 106.98342561721803], [-6.456986102698987, 106.98355302214625], [-6.456999028888504, 106.98356240987779], [-6.457143882185764, 106.9835288822651], [-6.4571234934490676, 106.98339343070984], [-6.456975441920532, 106.98342561721803]
  // ] //No Bid 21 kodam
  // const polyline186 = [
  //   [-6.456997429775849, 106.98356240987779], [-6.457014753539972, 106.98372066020967], [-6.457160539646465, 106.98373004794124], [-6.4571418832904515, 106.9835288822651], [-6.456997429775849, 106.98356240987779]
  // ] //No Bid 22 kodam
  // const polyline187 = [
  //   [-6.457016219384713, 106.9837233424187], [-6.4569878350591985, 106.98375418782236], [-6.457007424255234, 106.98384940624238], [-6.45714055069356, 106.9838373363018], [-6.457160539646465, 106.98373138904573], [-6.457016219384713, 106.9837233424187]
  // ] //No Bid 23 kodam
  // const polyline188 = [
  //   [-6.45662590149813, 106.98382660746574], [-6.456841782387516, 106.98377296328545], [-6.456986635729774, 106.98375552892688], [-6.457007957285997, 106.98384940624238], [-6.456690799044591, 106.98394864797594], [-6.45664149291358, 106.98392853140831], [-6.45662590149813, 106.98382660746574]
  // ] //No Bid 24 kodam
  // const polyline189 = [
  //   [-6.455929884974623, 106.98431879281999], [-6.455873915768455, 106.984228938818], [-6.455835270360595, 106.98424100875856], [-6.4557259971223875, 106.98435366153718], [-6.455702010310844, 106.98434159159663], [-6.455558089417731, 106.9843201339245], [-6.455458144329001, 106.98438584804536], [-6.455434157504774, 106.98448777198793], [-6.455348871009424, 106.98459237813951], [-6.455254256286824, 106.98465675115587], [-6.455152978536014, 106.98462322354318], [-6.455102339653013, 106.98466479778291], [-6.455017053101774, 106.98471307754518], [-6.455035709536081, 106.984950453043], [-6.455364862228395, 106.9847868382931], [-6.4553901816574015, 106.98476538062098], [-6.455424829295044, 106.9847519695759], [-6.455809950953839, 106.98445960879326], [-6.455936547974946, 106.98432952165605], [-6.455929884974623, 106.98431879281999]
  // ] //No Bid 41 polda
  // const polyline190 = [
  //   [-6.455038374740933, 106.98495849967003], [-6.455053033367325, 106.98496118187906], [-6.455057031174451, 106.98497459292415], [-6.455166304557016, 106.98523342609407], [-6.455194289199971, 106.98526158928873], [-6.455231602054857, 106.98529779911041], [-6.455740655728883, 106.9850939512253], [-6.455543430805956, 106.98470368981363], [-6.455443485714339, 106.98477074503901], [-6.455398177266296, 106.98477879166605], [-6.4553701926346, 106.98479756712916], [-6.455038374740933, 106.98495849967003]
  // ] //No Bid 39
  // const polyline191 = [
  //   [-6.455543430805956, 106.98470368981363], [-6.455739323128315, 106.98509126901628], [-6.456145766140438, 106.98489278554918], [-6.456104455554098, 106.98482170701028], [-6.456113783751309, 106.98479354381563], [-6.456035160369447, 106.98450788855556], [-6.456059147165201, 106.9845025241375], [-6.455960534775383, 106.98432952165605], [-6.4558219443572, 106.98447838425638], [-6.455543430805956, 106.98470368981363]
  // ] //No Bid 40 polda
  // const polyline192 = [
  //   [-6.455232934656761, 106.98529511690143], [-6.45533421239158, 106.98549360036853], [-6.45626303488328, 106.98510333895686], [-6.456239048097194, 106.98497727513315], [-6.456185744124007, 106.98487132787706], [-6.456145766140438, 106.98489144444467], [-6.455741988329452, 106.9850926101208], [-6.455232934656761, 106.98529511690143]
  // ] //No Bid 6352
  // const polyline193 = [
  //   [-6.455331547188293, 106.985492259264], [-6.455350203611009, 106.98552712798121], [-6.4555407656037636, 106.9854560494423], [-6.455616723860606, 106.98570281267168], [-6.456113783751309, 106.98558077216151], [-6.456059147165201, 106.98544129729271], [-6.456279026073398, 106.98536753654481], [-6.456284356469972, 106.98514223098755], [-6.456264367482475, 106.98510199785234], [-6.455331547188293, 106.985492259264]
  // ] //No Bid 6352
  // const polyline194 = [
  //   [-6.455616723860606, 106.98570013046266], [-6.45577930114397, 106.98614537715913], [-6.456245711093446, 106.98604211211205], [-6.4561950723197175, 106.985854357481], [-6.45620573311461, 106.98580071330073], [-6.456115116350898, 106.98558077216151], [-6.455616723860606, 106.98570013046266]
  // ] //No Bid 6354
  // const yellowOptions = { color: 'yellow' }

  // const polyline154 = [
  //   [-6.452778275995162, 106.98442081334382], [-6.452976834602718, 106.98429741447578], [-6.452982165034062, 106.98427997767921], [-6.453158069236973, 106.98418742852819], [-6.453246021315534, 106.98437789199838], [-6.453039467167479, 106.98448117148578], [-6.453139412733496, 106.9847360169741], [-6.4529168672462305, 106.98482185966489], [-6.452778275995162, 106.98442081334382]
  // ] //No Bid TINDIHAN 1, 8, 9 P
  // const polyline153 = [
  //   [-6.453328642951162, 106.98534630485406], [-6.45310476493951, 106.98543483012897], [-6.45299149328879, 106.98506195094076], [-6.452968838955607, 106.98502975993169], [-6.452927528110128, 106.98485270938191], [-6.452915534638232, 106.98482051837287], [-6.453139412733496, 106.9847360169741], [-6.453246021315534, 106.9850418315601], [-6.453259347386701, 106.98505256189645], [-6.453328642951162, 106.98534630485406]
  // ] //No Bid TINDIHAN 1 P
  // const polyline149 = [
  //   [-6.453942974367693, 106.98498696142265], [-6.4536191511759275, 106.98518413135311], [-6.453857687621218, 106.98547519172658], [-6.453973624288703, 106.98546848526638], [-6.453985617735548, 106.98536386448694], [-6.453960298236315, 106.98522571140646], [-6.4539589656310525, 106.98500842209536], [-6.453942974367693, 106.98498696142265]
  // ] //No Bid 4B P
  // const polyline150 = [
  //   [-6.453599162083229, 106.98518010747694], [-6.453840363749084, 106.98548592206296], [-6.453867015859815, 106.98556639958557], [-6.453813711636954, 106.9855583518333], [-6.453660461964995, 106.98562541643551], [-6.453632477237284, 106.98570052878995], [-6.453627146812785, 106.98585477737501], [-6.453599162083229, 106.98591781810104], [-6.453567179533267, 106.98591513551698], [-6.4535711773521225, 106.985885627092], [-6.453523203523788, 106.98584538833072], [-6.45349921660791, 106.9857528391797], [-6.453491220969029, 106.98569784620587], [-6.453483225330035, 106.98564553581619], [-6.453443247133126, 106.98564151194002], [-6.453392608079177, 106.9855207956561], [-6.453155404022236, 106.98561334480712], [-6.453103432332007, 106.98543629425734], [-6.453337971199503, 106.98534106252221], [-6.453599162083229, 106.98518010747694]
  // ] //No Bid 4A P
  // const polyline162 = [
  //   [-6.456027164770602, 106.98172375559807], [-6.456071140562659, 106.98180958628657], [-6.456061812364672, 106.98186323046687], [-6.456128442346584, 106.98200941085817], [-6.456129774946135, 106.9820335507393], [-6.4561417683419124, 106.98204696178438], [-6.4562004027171955, 106.98222398757936], [-6.456288354267378, 106.98264241218567], [-6.456309675853014, 106.98267325758937], [-6.456350986422611, 106.98266789317134], [-6.456377638401195, 106.98279798030855], [-6.456341658229763, 106.98282212018968], [-6.456227054703706, 106.98284894227984], [-6.456184411524597, 106.98277786374094], [-6.456169752930951, 106.98271349072458], [-6.456135105344286, 106.98260888457298], [-6.45609246215743, 106.98235675692558], [-6.456047153767476, 106.98223739862443], [-6.455969862975228, 106.98212742805482], [-6.455907230772872, 106.98202416300774], [-6.455855259365025, 106.98189944028856], [-6.455815281355362, 106.98175728321077], [-6.45599251717418, 106.98171973228456], [-6.456027164770602, 106.98172375559807]
  // ] //No Bid 6 Kodam
  // const polyline163 = [
  //   [-6.456201735316555, 106.9822280108929], [-6.456208398313291, 106.98220923542978], [-6.456380303598986, 106.98218911886217], [-6.456422946761582, 106.98258742690086], [-6.456277693474242, 106.98260888457298], [-6.456201735316555, 106.9822280108929]
  // ] //No Bid 7 kodam
  // const polyline172 = [
  //   [-6.456303012857601, 106.98175057768825], [-6.456305678055774, 106.98192089796068], [-6.456345656026723, 106.98199063539506], [-6.456373640604502, 106.98213681578639], [-6.456528222053903, 106.98212608695033], [-6.4564975722875175, 106.98171570897104], [-6.456303012857601, 106.98175057768825]
  // ] //No Bid kadus
  // const polyline132 = [
  //   [-6.4546938746937705, 106.98339611291887], [-6.454837795832499, 106.98396071791649], [-6.4545706310757724, 106.9840708651454], [-6.454381401322124, 106.98350081602678], [-6.4546938746937705, 106.98339611291887]
  // ] //No Bid 21A
  // const polyline133 = [
  //   [-6.454946425165655, 106.98327011379521], [-6.455082350618851, 106.98375566151508], [-6.455120996084178, 106.98385357583429], [-6.454837795832499, 106.98396340012552], [-6.4546938746937705, 106.98339611291887], [-6.454946425165655, 106.98327011379521]
  // ] //No Bid 21B
  // const polyline130 = [
  //   [-6.45513432210602, 106.98388308425929], [-6.455188958791909, 106.98402257863182], [-6.455330214586643, 106.98450141989146], [-6.455146315525385, 106.9844933721392], [-6.45508368322115, 106.98455507157324], [-6.455085015823449, 106.9845818974141], [-6.455049035560175, 106.98461140583909], [-6.455013055294331, 106.98462079488337], [-6.454842482147413, 106.98402257863182], [-6.45513432210602, 106.98388308425929]
  // ] //No Bid 20B
  // const polyline131 = [
  //   [-6.4550083689809945, 106.98459237813951], [-6.454843126244264, 106.98402106761934], [-6.455130968395988, 106.98388293385507], [-6.455120307578463, 106.98385342955592], [-6.454571275172967, 106.98406934738159], [-6.454584601209274, 106.98411092162135], [-6.45453529487318, 106.98412835597993], [-6.454711198536707, 106.98472380638124], [-6.454721859362832, 106.98471710085872], [-6.4547751634901225, 106.98471844196321], [-6.454824469802858, 106.9847318530083], [-6.454933743235601, 106.9847157597542], [-6.4550083689809945, 106.98461920022967], [-6.4550083689809945, 106.98459237813951]
  // ] //No Bid 20A
  // const polyline129 = [
  //   [-6.455188958791909, 106.98402123733979], [-6.4553608644236995, 106.98395953790578], [-6.455531437395993, 106.98427071765994], [-6.4554128358822815, 106.98431900417353], [-6.455331547188293, 106.9844998419285], [-6.455188958791909, 106.98402123733979]
  // ] //No Bid 29
  // const polyline128 = [
  //   [-6.4553608644236995, 106.98395953790578], [-6.4557259971223875, 106.98377578089575], [-6.455848596363634, 106.98414329491578], [-6.455721999320542, 106.98427071765994], [-6.45552743959262, 106.98426937636789], [-6.4553608644236995, 106.98395953790578]
  // ] //No Bid 30
  // const polyline112 = [
  //   [-6.455502120170471, 106.98163673983538], [-6.4555954022458115, 106.9816340572513], [-6.4558032879518485, 106.98196669767817], [-6.455829939959275, 106.9820927791303], [-6.455929884974623, 106.98218394104285], [-6.456005843173097, 106.98240395888446], [-6.455586074039045, 106.98241866715051], [-6.455666030091411, 106.98219467137922], [-6.45549012675954, 106.98209675705999], [-6.455502120170471, 106.98163673983538]
  // ] //No Bid 25
  // const polyline116 = [
  //   [-6.45480383666084, 106.98275797671788], [-6.454759860758724, 106.98278346126669], [-6.454917107906255, 106.98342023479653], [-6.455688684303951, 106.98295912232761], [-6.455463474734239, 106.98270159425518], [-6.4553608644236995, 106.98284377121182], [-6.455366194829955, 106.9829966785048], [-6.455296899544264, 106.98302618692978], [-6.45520361741395, 106.98303691726612], [-6.454802504057803, 106.98275524593694], [-6.45480383666084, 106.98275797671788]
  // ] //No Bid 27
  // const polyline117 = [
  //   [-6.455463474734239, 106.98270293554721], [-6.455586074039045, 106.98241858163391], [-6.456005843173097, 106.98240248612937], [-6.456013838772258, 106.98250308303271], [-6.456075138361756, 106.98266806195409], [-6.456108453352929, 106.98273378526423], [-6.455912561173377, 106.98279548469823], [-6.4559338827748265, 106.98283304087549], [-6.455688684303951, 106.98295643974353], [-6.455463474734239, 106.98270293554721]
  // ] //No Bid 26
  // const polyline121 = [
  //   [-6.45625237408961, 106.98345384736317], [-6.4564642573219295, 106.98380660717069], [-6.45608046876048, 106.98398499901255], [-6.455877913569105, 106.98362016757662], [-6.45625237408961, 106.98345384736317]
  // ] //No Bid 32
  // const redOptions = { color: 'red' }

  useEffect(() => {
    setAccTransData(accTranss);
  }, [accTranss]);

  const ParsedSVG = useMemo(() => {
    let content;

    if (isRincikProgress) {
      content = svgRincik && parse(svgRincik);
    } else if (isBuildingProgress || isBuildingOpname) {
      content = svgProject && parse(svgProject);
    } else {
      content = svg && parse(svg);
    }

    return <div>{content}</div>;
  }, [svgRincik, svgProject, svg, isRincikProgress, isBuildingProgress, isBuildingOpname]);

  return (
    <React.Fragment>
      <div className="page-content" style={{ overflowX: "hidden", width: "100%", padding: "0px" }}>
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Row className="mb-3 pb-1">
                  <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                      <div className="flex-grow-1">
                        <h4 className="fs-16 mb-1">
                          {date < 12 ? "Selamat Pagi" : date >= 12 && date <= 15 ? "Selamat Siang" : date < 18 ? "Selamat Sore" : "Selamat Malam"} {userData?.name}{" "}
                          {(loading || civilBudgetLoading || salesLoading) && (
                            <>
                              <Spinner color="primary" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                              &nbsp;
                              <Spinner color="success" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                            </>
                          )}
                        </h4>
                        <p>{userType !== "agent" ? positionMessage : ""}</p>
                      </div>
                      <div className="mt-3 mt-lg-0">
                        <form action="#">
                          <Row className="g-3 mb-0 align-items-center">
                            <div className="col-sm-auto">
                              <div className="input-group">
                                <Flatpickr
                                  className="form-control border-0 dash-filter-picker shadow"
                                  options={{
                                    mode: "range",
                                    dateFormat: "Y/m/d",
                                  }}
                                  onChange={(selectedDates, dateStr) => {
                                    let startat = "";
                                    let endat = "";
                                    let datearr = dateStr.split(" to ");
                                    if (datearr[1]) {
                                      startat = datearr[0];
                                      endat = datearr[1] ? datearr[1] : datearr[0];
                                    }
                                    //dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientId, startat: startat, endat: endat }));
                                  }}
                                />
                                <div className="input-group-text bg-primary border-primary text-white">
                                  <i className="ri-calendar-2-line"></i>
                                </div>
                                <UncontrolledDropdown className="card-header-dropdown ms-2 mt-2" direction="start">
                                  <DropdownToggle tag="a" className="text-reset" role="button">
                                    <span className="fw-semibold text-uppercase fs-12">Filter by: </span>
                                    <span className="text-muted">
                                      {filterBy} <i className="mdi mdi-chevron-down ms-1"></i>
                                    </span>
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Hari Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId, filter: "today" }));
                                      }}
                                    >
                                      Hari Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Kemarin");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId, filter: "yesterday" }));
                                      }}
                                    >
                                      Kemarin
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("7 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId, filter: "last7day" }));
                                      }}
                                    >
                                      7 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("30 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId, filter: "last30day" }));
                                      }}
                                    >
                                      30 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId, filter: "thismonth" }));
                                      }}
                                    >
                                      Bulan Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Lalu");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId, filter: "lastmonth" }));
                                      }}
                                    >
                                      Bulan Lalu
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </div>
                            </div>
                          </Row>
                        </form>
                      </div>
                    </div>
                  </Col>
                </Row>
                <div className={userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("viewFinancialReport") !== -1 ? "" : " d-none"}>
                  <Revenue data={dashboards} product={productList} />
                </div>
                <Row className="d-none">
                  <BestSellingProducts data={dashboards} />
                  <BestMarketing data={dashboards} />
                  <BestPartner data={dashboards} />
                </Row>
                {/* className={userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewSales") !== -1) ? "" : " d-none"} */}
                <Row>
                  <Col lg={9}>
                    <ReportBooking saless={saless} salesLoading={salesLoading} bankBranches={bankBranches} height="460px" />
                  </Col>
                  <Col lg={3}>
                    <Card className="" style={{ height: "460px" }}>
                      <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">UPDATE PENJUALAN TERAKHIR</h4>
                      </CardHeader>
                      <CardBody>
                        <SimpleBar style={{ maxHeight: "360px" }}>
                          {(salesHistoryList || [])
                            .sort((a, b) => new Date(b.createdat) - new Date(a.createdat))
                            .slice(0, 20)
                            .map((item, i) => {
                              const sales = item.sales;
                              let statDeal;
                              let statDealId = item.sales_history_status_deal && item.sales_history_status_deal.id;
                              switch (statDealId) {
                                case 3:
                                  statDeal =
                                    sales.typeId === 3 || sales.typeId === 4 ? (
                                      <span className="badge text-uppercase" style={{ background: "#CFECF7", color: "#20A7DB" }}>
                                        CASH
                                      </span>
                                    ) : (
                                      <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>
                                        {item.sales_history_status_deal.name}
                                      </span>
                                    );
                                  break;
                                case 4:
                                  statDeal = (
                                    <span className="badge text-uppercase" style={{ background: "#ede3c5", color: "#806b29" }}>
                                      {item.sales_history_status_deal.name}{" "}
                                    </span>
                                  );
                                  break;
                                case 5:
                                  statDeal = (
                                    <span className="badge text-uppercase" style={{ background: "#EAFAEA", color: "#65B741" }}>
                                      {item.sales_history_status_deal.name}
                                    </span>
                                  );
                                  break;
                                case 6:
                                  statDeal = (
                                    <span className="badge text-uppercase" style={{ background: "#FFFBCA", color: "#F09319" }}>
                                      {item.sales_history_status_deal.name}
                                    </span>
                                  );
                                  break;
                                case 7:
                                  statDeal = <span className="badge text-uppercase badge-soft-info">{item.sales_history_status_deal.name}</span>;
                                  break;
                                case 8:
                                  statDeal = (
                                    <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>
                                      {item.sales_history_status_deal.name}
                                    </span>
                                  );
                                  break;
                                default:
                                  statDeal = "";
                                  break;
                              }
                              return (
                                <div key={i} className="accordion-item mb-3 border-0">
                                  <div className="accordion-header">
                                    <button className="accordion-button p-0 shadow-none" type="button" id="headingOne">
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-1">
                                          {item?.sales_history_createdby && item?.sales_history_createdby?.image ? (
                                            <div className="profile-user position-relative d-inline-block mx-auto">
                                              <img src={`${api.MEDIA_URL}/media/${item?.sales_history_createdby?.image}-w-200`} alt="" className="rounded-circle avatar-sm img-thumbnail user-profile-image" />
                                            </div>
                                          ) : (
                                            <div className="flex-shrink-0 avatar-sm">
                                              <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.sales_history_createdby?.name.charAt(0)}</div>
                                            </div>
                                          )}
                                        </div>
                                        <div className="flex-grow-1 ms-3">
                                          <h6 className="fs-13 mb-1">
                                            {item?.sales_history_createdby?.name},
                                            <small className="ms-2 text-muted fs-10">
                                              <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}
                                            </small>
                                          </h6>
                                          <p className="fw-normal fs-12 text-muted mb-1">
                                            Memperbarui status penjualan atas nama{" "}
                                            <span className="text-dark me-1">
                                              {sales?.sales_customer?.name} #{sales.transaction_no}
                                            </span>{" "}
                                            {item.comment && <span className="fw-normal text-dark me-1">dengan catatan: {item.comment}.</span>}
                                            Status penjualan : {statDeal}
                                          </p>
                                        </div>
                                      </div>
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                        </SimpleBar>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12}>
                    <Card className="card-height-100">
                      <CardHeader className="align-items-center d-flex border-0 pb-0">
                        <Nav pills className="nav nav-pills arrow-navtabs nav-primary bg-light">
                          <NavItem>
                            <NavLink
                              style={{ fontSize: "14px", cursor: "pointer", padding: "10px 15px" }}
                              className={classnames({ active: justifyPillsTab === "1" })}
                              onClick={() => {
                                justifyPillsToggle("1");
                                setIsBuildingOpname(false);
                                setIsBuildingProgress(false);
                                setIsRincikProgress(false);
                              }}
                            >
                              PROGRESS PENJUALAN KPR
                            </NavLink>
                          </NavItem>
                          {(userType === "admin" || userType === "client" || userType === "company" || userType === "user" || userType === "holding") && (
                            <NavItem>
                              <NavLink
                                style={{ fontSize: "14px", cursor: "pointer", padding: "10px 15px" }}
                                className={classnames({ active: justifyPillsTab === "2" })}
                                onClick={() => {
                                  justifyPillsToggle("2");
                                  setIsBuildingOpname(false);
                                  setIsBuildingProgress(true);
                                  setIsRincikProgress(false);
                                }}
                              >
                                PROGRESS PEMBANGUNAN
                              </NavLink>
                            </NavItem>
                          )}
                          {(userType === "admin" || userType === "client" || userType === "company" || userType === "user" || userType === "holding") && (
                            <NavItem>
                              <NavLink
                                style={{ fontSize: "14px", cursor: "pointer", padding: "10px 15px" }}
                                className={classnames({ active: justifyPillsTab === "3" })}
                                onClick={() => {
                                  justifyPillsToggle("3");
                                  setIsBuildingOpname(true);
                                  setIsBuildingProgress(false);
                                  setIsRincikProgress(false);
                                }}
                              >
                                OPNAME PEMBANGUNAN
                              </NavLink>
                            </NavItem>
                          )}
                          {userRole && (userType === "admin" || userType === "client" || userType === "company" || userRole.split(",").indexOf("viewAsset") !== -1 || userRole.split(",").indexOf("viewLegal") !== -1) && (
                            <NavItem>
                              <NavLink
                                style={{ fontSize: "14px", cursor: "pointer", padding: "10px 15px" }}
                                className={classnames({ active: justifyPillsTab === "4" })}
                                onClick={() => {
                                  justifyPillsToggle("4");
                                  setIsBuildingOpname(false);
                                  setIsBuildingProgress(false);
                                  setIsRincikProgress(true);
                                }}
                              >
                                RINCIK
                              </NavLink>
                            </NavItem>
                          )}
                        </Nav>
                        {svg && (
                          <div className="d-flex justify-content-end px-3">
                            <button type="submit" className="btn btn-success" onClick={handlePrint}>
                              PRINT SITEPLAN &nbsp;
                              {loadingPrintSite && <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner>}
                            </button>
                          </div>
                        )}
                      </CardHeader>
                      <div style={{ position: "relative" }}>
                        <div ref={printSiteRef}>
                          <CardBody className="siteplan-svg">
                            <Siteplan salesLoading={salesLoading} justifyPillsTab={justifyPillsTab} component={ParsedSVG} />
                            {!isBuildingOpname && !isBuildingProgress && !isRincikProgress && (
                              <div className="hstack gap-3">
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #CCC" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark border border-light" style={{ background: "#FFF" }}>
                                        {productList.filter((p) => parseFloat(p.stocks) > 0).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> BLOK KOSONG</div>
                                  </div>
                                </div>
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #ed57f7" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#ed57f7" }}>
                                        {saless.filter((sales) => sales.statusDealId === 3 && sales.typeId !== 3 && sales.typeId !== 4 && sales.statusBankId !== 2 && sales.statusBankId !== 3 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> BOOKING</div>
                                  </div>
                                </div>
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #20A7DB" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#20A7DB" }}>
                                        {saless.filter((sales) => (sales.typeId === 4 || sales.typeId === 3) && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> CASH</div>
                                  </div>
                                </div>
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #BDB395" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#BDB395" }}>
                                        {saless.filter((sales) => sales.statusDealId === 4 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> KANTOR</div>
                                  </div>
                                </div>
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #75fb4c" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#75fb4c" }}>
                                        {saless.filter((sales) => sales.statusDealId === 5 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> BANK</div>
                                  </div>
                                </div>
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #FFC107" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#FFC107" }}>
                                        {saless.filter((sales) => sales.statusDealId === 6 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> SP3K</div>
                                  </div>
                                </div>
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #9ACBD0" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#9ACBD0" }}>
                                        {saless.filter((sales) => sales.statusDealId === 7 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> SP3K FINAL</div>
                                  </div>
                                </div>
                                <div className="card align-items-center p-2" style={{ width: 100 / 7 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #75fbfd" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 avatar-xs me-2">
                                      <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#75fbfd" }}>
                                        {saless.filter((sales) => sales.statusDealId === 8 && (sales.statusId === 2 || sales.statusId === 3 || sales.statusId === 4 || sales.statusId === 5)).length}
                                      </div>
                                    </div>
                                    <div className="col-auto fs-10 text-center flex-grow-1"> AKAD</div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </CardBody>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* <RecentActivity /> */}
          </Row>

          <div>
            <Graph data={dashboards} product={productList} />
          </div>

          <Row className={userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPurchase") !== -1 || userRole.split(",").indexOf("viewAccTransaction") !== -1 || userRole.split(",").indexOf("viewCivilBudget") !== -1) ? "" : " d-none"}>
            <Col lg={4}>
              <Card className="" style={{ height: "730px" }}>
                <CardHeader className="border-0 pb-0 align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">PROGRESS PEMBANGUNAN BY BLOK</h4>
                </CardHeader>

                {progressBlokList.length > 0 && (
                  <CardBody className="pb-3 pe-0 ps-0">
                    <SimpleBar style={{ maxHeight: "650px" }}>
                      <table className="table border table-responsive table-striped fs-13">
                        <thead className="align-middle">
                          <tr className="table-active text-center fs-13 fw-semibold">
                            <td>BLOK</td>
                            <td>UNIT</td>
                            <td>BOBOT</td>
                            <td></td>
                          </tr>
                        </thead>
                        <tbody>
                          {(progressBlokList.sort((a, b) => a.block.localeCompare(b.block, undefined, { numeric: true, sensitivity: "base" })) || []).map((obj, key) => {
                            let tUnit = progressUnitList.filter((item) => item.block === obj.block).length;
                            let percentage = parseFloat(obj.weight / tUnit).toFixed(2);
                            return (
                              <tr key={key} className="text-center fs-14">
                                <td className="fw-semibold">{obj.block}</td>
                                <td className="fs-12">{tUnit}</td>
                                <td className="fs-12">{percentage} %</td>
                                <td className="ps-4 pe-4" style={{ width: "280px" }}>
                                  <Progress value={percentage} color={percentage < 50 ? "danger" : percentage < 80 ? "warning" : "success"} className="animated-progess custom-progress progress-label mt-3 w-100">
                                    <div className={percentage < 50 ? "label text-danger bg-soft-danger fs-10" : percentage < 80 ? "label text-warning bg-soft-warning fs-10" : "label text-success bg-soft-success fs-10"}>{percentage} %</div>
                                  </Progress>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </SimpleBar>
                  </CardBody>
                )}
              </Card>
            </Col>
            <Col lg={8}>
              <Row>
                <Col sm={12}>
                  <Card className="" style={{ height: "730px" }}>
                    <CardHeader className="border-0 pb-0 align-items-center d-flex">
                      <h4 className="card-title mb-0 flex-grow-1">
                        GRAFIK PROGRESS PROYEK &nbsp;{" "}
                        {civilBudgetScheduleLoading && (
                          <>
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </>
                        )}
                      </h4>
                      <div className="d-flex gap-1">
                        <div style={{ width: "380px" }}>
                          <Select
                            name="budget"
                            value={civilBudget}
                            className="text-uppercase w-100"
                            placeholder="Pilih Aggaran Proyek"
                            onChange={(e) => {
                              setCivilBudget(e.data);
                              setUnit(parseInt(e.data.unit));
                              setStartAt(e.data.startat);
                              setEndAt(e.data.endat);
                              dispatch(resetCivilBudgetScheduleState());
                              dispatch(onGetCivilBudgetSchedules({ civilBudgetId: e.data.id }));
                            }}
                            options={civilBudgetSelectList}
                          ></Select>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <div className="pe-3" style={{ height: "650px" }}>
                        <ReactApexChart
                          options={{
                            chart: {
                              height: 650,
                              type: "line",
                              toolbar: {
                                show: true,
                              },
                            },
                            stroke: {
                              curve: "straight",
                              dashArray: [0, 0, 0, 0, 0, 0],
                              width: [2, 2, 2, 2, 2, 2],
                            },
                            fill: {
                              opacity: [0.5, 1, 1, 1, 1, 1],
                            },
                            markers: {
                              size: [0, 0, 0, 0, 0, 0],
                              strokeWidth: 2,
                              hover: {
                                size: 4,
                              },
                            },
                            xaxis: {
                              categories: chartProjectCategory,
                              axisTicks: {
                                show: false,
                              },
                              axisBorder: {
                                show: false,
                              },
                            },
                            grid: {
                              show: true,
                              xaxis: {
                                lines: {
                                  show: true,
                                },
                              },
                              yaxis: {
                                lines: {
                                  show: false,
                                },
                              },
                              padding: {
                                top: 0,
                                right: -2,
                                bottom: 15,
                                left: 10,
                              },
                            },
                            legend: {
                              show: true,
                              horizontalAlign: "center",
                              offsetX: 0,
                              offsetY: -5,
                              markers: {
                                width: 9,
                                height: 9,
                                radius: 6,
                              },
                              itemMargin: {
                                horizontal: 10,
                                vertical: 0,
                              },
                            },
                            colors: chartProjectColor,
                            tooltip: {
                              theme: "dark",
                              fillSeriesColor: true,
                              style: {
                                fontSize: "12px",
                                color: "#FFFFFF",
                              },
                              y: [
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                                {
                                  formatter: function (y) {
                                    if (typeof y !== "undefined") {
                                      return y.toFixed(2);
                                    }
                                    return y;
                                  },
                                },
                              ],
                            },
                          }}
                          series={chartProjectData} //chartData
                          type="area"
                          height="650"
                          className="apex-charts"
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className={userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPurchase") !== -1 || userRole.split(",").indexOf("viewAccTransaction") !== -1 || userRole.split(",").indexOf("viewCivilBudget") !== -1) ? "" : " d-none"}>
            <Col lg={4}>
              <Card className="" style={{ height: "730px" }}>
                <CardHeader className="border-0 pb-0 align-items-center d-flex">
                  <h4 className="card-title mb-0 p-2 flex-grow-1">UPDATE PROGRESS PEMBANGUNAN TERAKHIR</h4>
                </CardHeader>

                {progressBlokList.length > 0 && (
                  <CardBody className="pe-0 ps-0">
                    <SimpleBar style={{ maxHeight: "630px" }}>
                      {(civilProgressions || []).slice(0, 20).map((item, idx) => {
                        return (
                          <div key={idx} className="accordion-item border-0">
                            <div className="accordion-header">
                              <div className="accordion-button ps-3 pe-3 mb-3 shadow-none" id="headingOne">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 me-1">
                                    {item?.cvlp_createdby && item?.cvlp_createdby?.image ? (
                                      <div className="profile-user position-relative d-inline-block mx-auto">
                                        <img src={`${api.MEDIA_URL}/media/${item?.cvlp_createdby?.image}-w-200`} alt="" className="rounded-circle avatar-sm img-thumbnail user-profile-image" />
                                      </div>
                                    ) : (
                                      <div className="flex-shrink-0 avatar-sm">
                                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.cvlp_createdby?.name.charAt(0)}</div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="flex-grow-1 ms-3 mt-1">
                                    <h6 className="fs-14 mb-1">
                                      {item.cvlp_createdby.name}{" "}
                                      <small className="text-muted">
                                        <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}
                                      </small>
                                    </h6>
                                    <p className="fw-normal text-muted mb-2">
                                      Memperbarui progress pembangunan{" "}
                                      <b className="text-dark">
                                        {item?.cvlp_product?.product_block?.name} {item?.cvlp_product?.name}
                                      </b>{" "}
                                      dengan catatan: {item.description || "-"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </SimpleBar>
                  </CardBody>
                )}
              </Card>
            </Col>
            <Col lg={8}>
              <Card className="" style={{ height: "730px" }}>
                <CardHeader className="border-0 pb-0 align-items-center hstack gap-3">
                  <h4 className="card-title mb-0">PENGELUARAN PERSEDIAAN MATERIAL {block.label ? ` - ${block.label} (${block.unit} unit)` : ""}</h4>
                  <div className="">
                    <div style={{ minWidth: "80px" }}>
                      <Select
                        name="budget"
                        value={block}
                        className="text-uppercase w-100"
                        placeholder="Pilih Blok"
                        onChange={(e) => {
                          setBlock(e);
                        }}
                        options={blockList}
                      ></Select>
                    </div>
                  </div>
                  &nbsp;{" "}
                  {transferLoading && (
                    <div>
                      <Spinner color="primary" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                      <Spinner color="success" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                    </div>
                  )}
                </CardHeader>
                <CardBody>
                  <Row className="mb-2 m-0 p-0 pb-2 border-bottom">
                    <div className="hstack gap-2 col-sm-4">
                      <div className="ms-2">
                        <Label className="form-check-label fw-semibold text-uppercase">Uraian Pekerjaan</Label>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="hstack p-2 cursor-pointer form-check-label fw-semibold text-uppercase">
                        <div style={{ width: "40%" }}>Kebutuhan Material</div>
                        <div style={{ width: "20%" }}>Anggaran</div>
                        <div style={{ width: "20%" }}>Realisasi</div>
                        <div style={{ width: "20%" }}>Sisa</div>
                      </div>
                    </div>
                  </Row>
                  <SimpleBar style={{ maxHeight: "580px" }}>
                    {(civilBudgetList || [])
                      .filter((f) => f.type === "PROGRESS BANGUNAN")
                      .map((obj, i) => {
                        return (
                          <div key={i}>
                            {(obj.data || []).map((o, idx) => {
                              return (
                                <Row key={idx} className="mb-2 m-0 p-0 pb-2 border-bottom">
                                  <div className="hstack gap-2 col-sm-4">
                                    <em className="avatar-xs rounded-circle" style={{ background: o.cvld_account.color, width: "20px", height: "18px", display: "block", float: "left" }}>
                                      &nbsp;
                                    </em>
                                    <div className="ms-2">
                                      <Label className="form-check-label fw-semibold text-uppercase">{o.cvld_account.name}</Label>
                                    </div>
                                  </div>
                                  <div className="col-sm-8">
                                    {(o.cvld_material || []).map((mat, m) => {
                                      let item = {};
                                      let arr = (transferList || []).filter((f) => f.cvlAccountId === o.civilAccountId && f.productId === mat.productId && f.blockId === block.value);
                                      arr.forEach((element) => {
                                        item.name = element.name;
                                        item.quantity = parseFloat(item?.quantity || 0) + parseFloat(element.quantity);
                                        item.uom = element?.transfer_detail_product?.product_uom?.name;
                                      });
                                      let sisa = block.unit ? parseFloat(mat.quantity * block.unit) - parseFloat(item?.quantity || 0) : parseFloat(mat.quantity).toFixed(2);
                                      return (
                                        <div
                                          key={m}
                                          className="hstack p-2 cursor-pointer"
                                          onClick={() => {
                                            expanseDataRef.current = arr;
                                            setLabel(item.name);
                                            setExpense(arr);
                                            toggleMaterial();
                                          }}
                                        >
                                          <div style={{ width: "40%" }}>{mat?.cvlm_material?.name}</div>
                                          <div style={{ width: "20%" }}>
                                            <span className="fw-semibold">{block.unit ? parseFloat(mat.quantity * block.unit).toFixed(2) : parseFloat(mat.quantity)}</span>
                                          </div>
                                          <div style={{ width: "20%" }}>
                                            <span className="fw-semibold">{parseFloat(item?.quantity || 0).toFixed(2)}</span>
                                          </div>
                                          <div style={{ width: "20%" }}>
                                            <span className={sisa < 0 ? "fw-semibold text-danger" : "fw-semibold text-success"}>
                                              {parseFloat(sisa).toFixed(2)} {item?.uom}
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </Row>
                              );
                            })}
                          </div>
                        );
                      })}
                  </SimpleBar>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className={userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewAsset") !== -1 || userRole.split(",").indexOf("viewLegal") !== -1) ? "" : " d-none"}>
            <Col lg={3}>
              <Card className="" style={{ height: "800px" }}>
                <CardHeader className="border-0 align-items-center d-flex">
                  <h4 className="card-title p-2 mb-0 flex-grow-1">
                    SUMMARY ASET & PERTANAHAN&nbsp;{" "}
                    {legalLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h4>
                </CardHeader>
                <CardBody className="pt-0">
                  <div className="card shadow-none mb-3 align-items-center card-animate p-2 bg-soft-info">
                    <div className="fs-17 fw-semibold">
                      <CountUp start={0} prefix="" suffix={" M²"} separator="." end={landTotal} decimals={0} duration={2} />
                    </div>
                    <div className="col-auto fs-12 text-center text-muted flex-grow-1">Rencana Pembebasan Tanah</div>
                  </div>
                  <div className="card shadow-none mb-3 align-items-center card-animate p-2 bg-soft-info">
                    <div className="fs-17 fw-semibold">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={priceTotal} decimals={0} duration={2} />
                    </div>
                    <div className="col-auto fs-12 text-center text-muted flex-grow-1">Estimasi Harga Tanah</div>
                  </div>
                  <div className="card shadow-none mb-3 align-items-center card-animate p-2 bg-soft-success">
                    <div className="fs-17 fw-semibold">
                      <CountUp start={0} prefix="" suffix={" M²"} separator="." end={landPaidTotal} decimals={0} duration={2} />
                    </div>
                    <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Dibebaskan</div>
                  </div>
                  <div className="card shadow-none mb-3 align-items-center card-animate p-2 bg-soft-success">
                    <div className="fs-17 fw-semibold">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={paidTotal} decimals={0} duration={2} />
                    </div>
                    <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Terbayar</div>
                  </div>
                  <div className="card shadow-none mb-3 align-items-center card-animate p-2 bg-soft-warning">
                    <div className="fs-17 fw-semibold">
                      <CountUp start={0} prefix="" suffix={" M²"} separator="." end={landUnpaidTotal} decimals={0} duration={2} />
                    </div>
                    <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Belum Dibebaskan</div>
                  </div>
                  <div className="card shadow-none mb-3 align-items-center card-animate p-2 bg-soft-warning">
                    <div className="fs-17 fw-semibold">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={priceTotal - paidTotal} decimals={0} duration={2} />
                    </div>
                    <div className="col-auto fs-12 text-center text-muted flex-grow-1">Menunggu Pembayaran</div>
                  </div>
                  {legalStatus.length &&
                    legalStatus
                      .sort((a, b) => a.id - b.id)
                      .map((o, i) => {
                        return (
                          <div className="mb-2 align-items-center border-bottom border-info d-flex" key={i}>
                            <h4 className="card-title mb-0 p-0 fs-12 text-left fw-semibold flex-grow-1">{o.label}</h4>
                            <button className="btn btn-sm mb-1 btn-icon btn-topbar btn-info rounded-circle shadow-none">{o.amount}</button>
                          </div>
                        );
                      })}
                </CardBody>
              </Card>
            </Col>
            <Col lg={9}>
              <Card className="" style={{ height: "800px" }}>
                <CardHeader className="border-0 align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    LOKASI ASET & PERTANAHAN&nbsp;{" "}
                    {legalLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h4>
                  <button
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none"
                    onClick={() => {
                      setIsFullscreenMap(true);
                    }}
                  >
                    <i className="bx bx-fullscreen fs-22"></i>
                  </button>
                </CardHeader>
                <CardBody className="pt-0">
                  <div style={{ height: "710px" }}>
                    <Fullscreen enabled={isFullscreenMap} onChange={(isFullscreenMap) => setIsFullscreenMap(true)}>
                      <MapContainer center={[-6.45543862539251, 106.985199676624]} zoom={17} style={{ height: "100%" }}>
                        <TileLayer url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}" maxZoom={20} subdomains={["mt1", "mt2", "mt3"]} />
                        {/* <Polyline pathOptions={limeOptions} positions={polyline} />
                        <Polyline pathOptions={yellowOptions} positions={polyline1} />
                        <Polyline pathOptions={yellowOptions} positions={polyline2} />
                        <Polyline pathOptions={yellowOptions} positions={polyline3} />
                        <Polyline pathOptions={yellowOptions} positions={polyline4} />
                        <Polyline pathOptions={yellowOptions} positions={polyline5} />
                        <Polyline pathOptions={yellowOptions} positions={polyline6} />
                        <Polyline pathOptions={yellowOptions} positions={polyline7} />
                        <Polyline pathOptions={yellowOptions} positions={polyline8} />
                        <Polyline pathOptions={yellowOptions} positions={polyline9} />
                        <Polyline pathOptions={yellowOptions} positions={polyline10} />
                        <Polyline pathOptions={yellowOptions} positions={polyline11} />
                        <Polyline pathOptions={yellowOptions} positions={polyline12} />
                        <Polyline pathOptions={yellowOptions} positions={polyline13} />
                        <Polyline pathOptions={yellowOptions} positions={polyline14} />
                        <Polyline pathOptions={yellowOptions} positions={polyline15} />
                        <Polyline pathOptions={yellowOptions} positions={polyline16} />
                        <Polyline pathOptions={yellowOptions} positions={polyline17} />
                        <Polyline pathOptions={yellowOptions} positions={polyline18} />
                        <Polyline pathOptions={yellowOptions} positions={polyline19} />
                        <Polyline pathOptions={yellowOptions} positions={polyline20} />
                        <Polyline pathOptions={yellowOptions} positions={polyline21} />
                        <Polyline pathOptions={yellowOptions} positions={polyline22} />
                        <Polyline pathOptions={yellowOptions} positions={polyline23} />
                        <Polyline pathOptions={yellowOptions} positions={polyline24} />
                        <Polyline pathOptions={yellowOptions} positions={polyline25} />
                        <Polyline pathOptions={yellowOptions} positions={polyline26} />
                        <Polyline pathOptions={yellowOptions} positions={polyline27} />
                        <Polyline pathOptions={yellowOptions} positions={polyline28} />
                        <Polyline pathOptions={yellowOptions} positions={polyline29} />
                        <Polyline pathOptions={yellowOptions} positions={polyline30} />
                        <Polyline pathOptions={yellowOptions} positions={polyline31} />
                        <Polyline pathOptions={yellowOptions} positions={polyline32} />
                        <Polyline pathOptions={yellowOptions} positions={polyline33} />
                        <Polyline pathOptions={yellowOptions} positions={polyline34} />
                        <Polyline pathOptions={yellowOptions} positions={polyline35} />
                        <Polyline pathOptions={yellowOptions} positions={polyline36} />
                        <Polyline pathOptions={yellowOptions} positions={polyline37} />
                        <Polyline pathOptions={yellowOptions} positions={polyline38} />
                        <Polyline pathOptions={yellowOptions} positions={polyline39} />
                        <Polyline pathOptions={yellowOptions} positions={polyline40} />
                        <Polyline pathOptions={yellowOptions} positions={polyline41} />
                        <Polyline pathOptions={yellowOptions} positions={polyline42} />
                        <Polyline pathOptions={yellowOptions} positions={polyline43} />
                        <Polyline pathOptions={yellowOptions} positions={polyline44} />
                        <Polyline pathOptions={yellowOptions} positions={polyline45} />
                        <Polyline pathOptions={yellowOptions} positions={polyline46} />
                        <Polyline pathOptions={yellowOptions} positions={polyline47} />
                        <Polyline pathOptions={yellowOptions} positions={polyline48} />
                        <Polyline pathOptions={yellowOptions} positions={polyline49} />
                        <Polyline pathOptions={yellowOptions} positions={polyline50} />
                        <Polyline pathOptions={yellowOptions} positions={polyline51} />
                        <Polyline pathOptions={yellowOptions} positions={polyline52} />
                        <Polyline pathOptions={yellowOptions} positions={polyline53} />
                        <Polyline pathOptions={yellowOptions} positions={polyline54} />
                        <Polyline pathOptions={yellowOptions} positions={polyline55} />
                        <Polyline pathOptions={yellowOptions} positions={polyline56} />
                        <Polyline pathOptions={yellowOptions} positions={polyline57} />
                        <Polyline pathOptions={yellowOptions} positions={polyline58} />
                        <Polyline pathOptions={yellowOptions} positions={polyline59} />
                        <Polyline pathOptions={yellowOptions} positions={polyline60} />
                        <Polyline pathOptions={yellowOptions} positions={polyline61} />
                        <Polyline pathOptions={yellowOptions} positions={polyline62} />
                        <Polyline pathOptions={yellowOptions} positions={polyline63} />
                        <Polyline pathOptions={yellowOptions} positions={polyline64} />
                        <Polyline pathOptions={yellowOptions} positions={polyline65} />
                        <Polyline pathOptions={yellowOptions} positions={polyline66} />
                        <Polyline pathOptions={yellowOptions} positions={polyline67} />
                        <Polyline pathOptions={yellowOptions} positions={polyline68} />
                        <Polyline pathOptions={yellowOptions} positions={polyline69} />
                        <Polyline pathOptions={yellowOptions} positions={polyline70} />
                        <Polyline pathOptions={yellowOptions} positions={polyline71} />
                        <Polyline pathOptions={yellowOptions} positions={polyline72} />
                        <Polyline pathOptions={yellowOptions} positions={polyline73} />
                        <Polyline pathOptions={yellowOptions} positions={polyline74} />
                        <Polyline pathOptions={yellowOptions} positions={polyline75} />
                        <Polyline pathOptions={yellowOptions} positions={polyline76} />
                        <Polyline pathOptions={yellowOptions} positions={polyline77} />
                        <Polyline pathOptions={yellowOptions} positions={polyline78} />
                        <Polyline pathOptions={yellowOptions} positions={polyline79} />
                        <Polyline pathOptions={yellowOptions} positions={polyline80} />
                        <Polyline pathOptions={yellowOptions} positions={polyline81} />
                        <Polyline pathOptions={yellowOptions} positions={polyline82} />
                        <Polyline pathOptions={yellowOptions} positions={polyline83} />
                        <Polyline pathOptions={yellowOptions} positions={polyline84} />
                        <Polyline pathOptions={yellowOptions} positions={polyline85} />
                        <Polyline pathOptions={yellowOptions} positions={polyline86} />
                        <Polyline pathOptions={yellowOptions} positions={polyline87} />
                        <Polyline pathOptions={yellowOptions} positions={polyline88} />
                        <Polyline pathOptions={yellowOptions} positions={polyline89} />
                        <Polyline pathOptions={yellowOptions} positions={polyline90} />
                        <Polyline pathOptions={yellowOptions} positions={polyline91} />
                        <Polyline pathOptions={yellowOptions} positions={polyline92} />
                        <Polyline pathOptions={yellowOptions} positions={polyline93} />
                        <Polyline pathOptions={yellowOptions} positions={polyline94} />
                        <Polyline pathOptions={yellowOptions} positions={polyline95} />
                        <Polyline pathOptions={yellowOptions} positions={polyline96} />
                        <Polyline pathOptions={yellowOptions} positions={polyline97} />
                        <Polyline pathOptions={yellowOptions} positions={polyline98} />
                        <Polyline pathOptions={yellowOptions} positions={polyline99} />
                        <Polyline pathOptions={yellowOptions} positions={polyline100} />
                        <Polyline pathOptions={yellowOptions} positions={polyline101} />
                        <Polyline pathOptions={yellowOptions} positions={polyline102} />
                        <Polyline pathOptions={yellowOptions} positions={polyline103} />
                        <Polyline pathOptions={yellowOptions} positions={polyline104} />
                        <Polyline pathOptions={yellowOptions} positions={polyline105} />
                        <Polyline pathOptions={yellowOptions} positions={polyline106} />
                        <Polyline pathOptions={yellowOptions} positions={polyline107} />
                        <Polyline pathOptions={yellowOptions} positions={polyline108} />
                        <Polyline pathOptions={yellowOptions} positions={polyline109} />
                        <Polyline pathOptions={yellowOptions} positions={polyline110} />
                        <Polyline pathOptions={yellowOptions} positions={polyline111} />
                        <Polyline pathOptions={redOptions} positions={polyline112} />
                        <Polyline pathOptions={yellowOptions} positions={polyline114} />
                        <Polyline pathOptions={yellowOptions} positions={polyline115} />
                        <Polyline pathOptions={redOptions} positions={polyline116} />
                        <Polyline pathOptions={redOptions} positions={polyline117} />
                        <Polyline pathOptions={yellowOptions} positions={polyline118} />
                        <Polyline pathOptions={yellowOptions} positions={polyline119} />
                        <Polyline pathOptions={yellowOptions} positions={polyline120} />
                        <Polyline pathOptions={redOptions} positions={polyline121} />
                        <Polyline pathOptions={redOptions} positions={polyline128} />
                        <Polyline pathOptions={redOptions} positions={polyline129} />
                        <Polyline pathOptions={redOptions} positions={polyline130} />
                        <Polyline pathOptions={redOptions} positions={polyline131} />
                        <Polyline pathOptions={redOptions} positions={polyline132} />
                        <Polyline pathOptions={redOptions} positions={polyline133} />
                        <Polyline pathOptions={yellowOptions} positions={polyline134} />
                        <Polyline pathOptions={yellowOptions} positions={polyline135} />
                        <Polyline pathOptions={yellowOptions} positions={polyline136} />
                        <Polyline pathOptions={yellowOptions} positions={polyline137} />
                        <Polyline pathOptions={yellowOptions} positions={polyline138} />
                        <Polyline pathOptions={yellowOptions} positions={polyline139} />
                        <Polyline pathOptions={yellowOptions} positions={polyline140} />
                        <Polyline pathOptions={yellowOptions} positions={polyline141} />
                        <Polyline pathOptions={yellowOptions} positions={polyline142} />
                        <Polyline pathOptions={yellowOptions} positions={polyline143} />
                        <Polyline pathOptions={yellowOptions} positions={polyline144} />
                        <Polyline pathOptions={yellowOptions} positions={polyline145} />
                        <Polyline pathOptions={yellowOptions} positions={polyline146} />
                        <Polyline pathOptions={yellowOptions} positions={polyline147} />
                        <Polyline pathOptions={yellowOptions} positions={polyline148} />
                        <Polyline pathOptions={yellowOptions} positions={polyline151} />
                        <Polyline pathOptions={yellowOptions} positions={polyline152} />
                        <Polyline pathOptions={redOptions} positions={polyline153} />
                        <Polyline pathOptions={redOptions} positions={polyline154} />
                        <Polyline pathOptions={yellowOptions} positions={polyline155} />
                        <Polyline pathOptions={yellowOptions} positions={polyline156} />
                        <Polyline pathOptions={redOptions} positions={polyline149} />
                        <Polyline pathOptions={redOptions} positions={polyline150} />
                        <Polyline pathOptions={yellowOptions} positions={polyline157} />
                        <Polyline pathOptions={yellowOptions} positions={polyline158} />
                        <Polyline pathOptions={yellowOptions} positions={polyline159} />
                        <Polyline pathOptions={yellowOptions} positions={polyline160} />
                        <Polyline pathOptions={yellowOptions} positions={polyline161} />
                        <Polyline pathOptions={redOptions} positions={polyline162} />
                        <Polyline pathOptions={redOptions} positions={polyline163} />
                        <Polyline pathOptions={yellowOptions} positions={polyline164} />
                        <Polyline pathOptions={yellowOptions} positions={polyline165} />
                        <Polyline pathOptions={yellowOptions} positions={polyline166} />
                        <Polyline pathOptions={yellowOptions} positions={polyline167} />
                        <Polyline pathOptions={yellowOptions} positions={polyline168} />
                        <Polyline pathOptions={yellowOptions} positions={polyline169} />
                        <Polyline pathOptions={yellowOptions} positions={polyline170} />
                        <Polyline pathOptions={yellowOptions} positions={polyline171} />
                        <Polyline pathOptions={redOptions} positions={polyline172} />
                        <Polyline pathOptions={yellowOptions} positions={polyline173} />
                        <Polyline pathOptions={yellowOptions} positions={polyline174} />
                        <Polyline pathOptions={yellowOptions} positions={polyline175} />
                        <Polyline pathOptions={yellowOptions} positions={polyline176} />
                        <Polyline pathOptions={yellowOptions} positions={polyline177} />
                        <Polyline pathOptions={yellowOptions} positions={polyline178} />
                        <Polyline pathOptions={yellowOptions} positions={polyline179} />
                        <Polyline pathOptions={yellowOptions} positions={polyline180} />
                        <Polyline pathOptions={yellowOptions} positions={polyline181} />
                        <Polyline pathOptions={yellowOptions} positions={polyline182} />
                        <Polyline pathOptions={yellowOptions} positions={polyline183} />
                        <Polyline pathOptions={yellowOptions} positions={polyline184} />
                        <Polyline pathOptions={yellowOptions} positions={polyline185} />
                        <Polyline pathOptions={yellowOptions} positions={polyline186} />
                        <Polyline pathOptions={yellowOptions} positions={polyline187} />
                        <Polyline pathOptions={yellowOptions} positions={polyline188} />
                        <Polyline pathOptions={redOptions} positions={polyline189} />
                        <Polyline pathOptions={redOptions} positions={polyline190} />
                        <Polyline pathOptions={redOptions} positions={polyline191} />
                        <Polyline pathOptions={redOptions} positions={polyline192} />
                        <Polyline pathOptions={redOptions} positions={polyline193} />
                        <Polyline pathOptions={redOptions} positions={polyline194} />
                        <Polyline pathOptions={yellowOptions} positions={polyline122} />
                        <Polyline pathOptions={yellowOptions} positions={polyline123} />
                        <Polyline pathOptions={yellowOptions} positions={polyline124} />
                        <Polyline pathOptions={yellowOptions} positions={polyline125} />
                        <Polyline pathOptions={yellowOptions} positions={polyline126} /> */}
                        {((assetList && assetList.filter((asset) => asset.longitude && !isNaN(parseFloat(asset.longitude)))) || []).map((item, i) => {
                          let total_bayar = item.legal_trans.reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);

                          return (
                            <Marker key={i} icon={total_bayar >= item.price ? greenIcon : item.legal_trans.length > 0 && total_bayar > 0 && total_bayar < item.price ? yellowIcon : item.statusId === 1 ? greyIcon : item.statusId === 2 ? blueIcon : greyIcon} position={[item.latitude, item.longitude]}>
                              <Popup maxWidth="580" maxHeight="auto">
                                <div style={{ width: "580px" }}>
                                  <h4 className="mb-2">{item.name && item.name}</h4>
                                  <Link to={"http://maps.google.com/maps?q=&layer=c&cbll=" + item.latitude + "," + item.longitude} target="_blank" className="text-decoration-underline mb-2">
                                    <i className="ri-external-link-line"></i> Street View
                                  </Link>
                                  <table className="table table-responsive table-striped">
                                    <tbody>
                                      {item.type === "nominatif" && (
                                        <tr>
                                          <td className="w-50">Status</td>
                                          <td className="w-50">
                                            <div>{item.legal_status_legal && item.legal_status_legal.name}</div>
                                          </td>
                                        </tr>
                                      )}
                                      {item.type === "nominatif" && (
                                        <tr>
                                          <td className="w-50">Luas Tanah</td>
                                          <td className="w-50">
                                            {item.quantity} M<sup>2</sup>{" "}
                                          </td>
                                        </tr>
                                      )}
                                      <tr>
                                        <td className="w-50">Harga Beli / Jual</td>
                                        <td className="w-50">
                                          {item.njop && currencyFormat(item.njop)} / {item.price && currencyFormat(item.price)}
                                        </td>
                                      </tr>
                                      {item.owner && (
                                        <tr>
                                          <td className="w-50">Pemilik Asal</td>
                                          <td className="w-50">{item.owner}</td>
                                        </tr>
                                      )}
                                      {item.nominatif && (
                                        <tr>
                                          <td className="w-50">Nominatif</td>
                                          <td className="w-50">{item.nominatif}</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                  <div style={{ height: "300px", overflow: "scroll" }}>
                                    <h5>Dokumen Legalitas</h5>
                                    <table className="table table-responsive">
                                      <tbody>
                                        {(item.legal_profile || []).map((file, key) => {
                                          let src;
                                          return (
                                            <tr
                                              key={key}
                                              onClick={() => {
                                                const typeFile = file.filename.split(".");
                                                if (typeFile[typeFile.length - 1] === "x-compressed") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "sheet") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "pdf") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else {
                                                  setImageActive({ index: 0, urls: [{ src: `${api.MEDIA_URL}/media/${file.filename}` }] });
                                                  setIsOpenImage(true);
                                                }
                                              }}
                                            >
                                              <td colSpan={2}>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 fs-12 me-2 filelist-icon">
                                                    <span className="fs-12 text-info">{renderIcon(file.filename)}</span>
                                                  </div>
                                                  <div className="flex-grow-1 text-start">
                                                    {file.description && <p className="fw-semibold mb-1 mt-1">{file.description}</p>}
                                                    <p className="mb-0 mt-0">{file.originalname}</p>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                        {(item.legal_detail || []).map((file, key) => {
                                          let src;
                                          return (
                                            <tr
                                              key={key}
                                              onClick={() => {
                                                const typeFile = file.filename.split(".");
                                                if (typeFile[typeFile.length - 1] === "x-compressed") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "sheet") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "pdf") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else {
                                                  setImageActive({ index: 0, urls: [{ src: `${api.MEDIA_URL}/media/${file.filename}` }] });
                                                  setIsOpenImage(true);
                                                }
                                              }}
                                            >
                                              <td colSpan={2}>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 fs-12 me-2 filelist-icon">
                                                    <span className="fs-12 text-info">{renderIcon(file.filename)}</span>
                                                  </div>
                                                  <div className="flex-grow-1 text-start">
                                                    {file.description && <p className="fw-semibold mb-1 mt-1">{file.description}</p>}
                                                    <p className="mb-0 mt-0">{file.originalname}</p>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        })}

                                        {item.legal_file && (
                                          <tr>
                                            <td colSpan={2}>
                                              <div className="row">
                                                {item.legal_file.length > 0 &&
                                                  item.legal_file.map((f, i) => {
                                                    return (
                                                      <div key={i} className="col-lg-4">
                                                        <div className="position-relative d-inline-block mx-auto">
                                                          <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={item.originalname} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                                                        </div>
                                                      </div>
                                                    );
                                                  })}
                                              </div>
                                            </td>
                                          </tr>
                                        )}

                                        {item.legality &&
                                          item.legality
                                            .filter((leg) => leg && leg.description && leg.description !== "")
                                            .map((o, idx) => {
                                              let row = o || {};
                                              return (
                                                <Fragment key={idx}>
                                                  <tr>
                                                    <td className="p2 border-top-0" colSpan={2}>
                                                      <span className="fw-semibold">{row.name ? row.name : "-"}</span>, {row.actualat ? row.actualat : "-"}, {row.description ? row.description : "-"}
                                                    </td>
                                                  </tr>
                                                </Fragment>
                                              );
                                            })}
                                      </tbody>
                                    </table>
                                    <h5>Riwayat Transaksi</h5>
                                    <table className="table table-responsive">
                                      <tbody>
                                        <tr>
                                          <td className="w-25">Transaksi</td>
                                          <td className="w-25">Tanggal</td>
                                          <td className="w-25">Pembayaran</td>
                                          <td className="w-50">Keterangan</td>
                                        </tr>

                                        {(item.legal_trans || []).map((o, key) => {
                                          return (
                                            <tr key={key}>
                                              <td className="w-25">{o.code}</td>
                                              <td className="w-25">{handleValidDate(o.transactionat)}</td>
                                              <td className="w-25">{currencyFormat(o.amount)}</td>
                                              <td className="w-50">{o.description}</td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </Popup>
                            </Marker>
                          );
                        })}
                        <Markers />
                      </MapContainer>
                    </Fullscreen>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div className={userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && (userRole.split(",").indexOf("viewPurchase") !== -1 || userRole.split(",").indexOf("viewAccTransaction") !== -1 || userRole.split(",").indexOf("viewCivilBudgetMonitoring") !== -1) ? "" : " d-none"}>
            <Expense data={dashboards} />
          </div>
          <Modal id="showModal" isOpen={modal} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggle}>
              {isBuildingProgress || isBuildingOpname ? "PROGRESS PEMBANGUNAN" : "DETAIL PENJUALAN"}
            </ModalHeader>
            {!isBuildingProgress && !isBuildingOpname ? (
              <ModalBody>
                <CardBody className="pt-4 ps-4 pe-4">
                  <Row>
                    <Col lg={5} className="ms-auto">
                      <div className="row">
                        <div className="mb-1 fs-14 fw-semibold">{info.sales_client && info.sales_client.name}</div>
                        <div className="mb-3 fs-14 fw-semibold">{info.sales_company && info.sales_company.name}</div>
                        <div className="mb-1 fs-14">{info.sales_branch && info.sales_branch.name}</div>
                        <div className="mb-3 fs-14">
                          PENJUALAN {info.sales_type && info.sales_type.name} {info.tenor ? ", Tenor " + info.tenor + " Bulan" : ""}
                        </div>
                      </div>
                    </Col>
                    <Col lg={3}></Col>
                    <Col lg={4} className="ms-auto">
                      <div className="mb-2 fs-14 fw-semibold">No Penjualan : {info.transaction_no && info.transaction_no}</div>
                      <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {info.sls_bb && info.sls_bb.name}</div>
                      <div className="mb-2 fs-14 fw-semibold">{info.sales_customer && info.sales_customer.name}</div>
                      <div className="mb-2 fs-14 fw-semibold">
                        <span className="badge text-uppercase badge-soft-info fs-12">{info.sales_agent && info.sales_agent.name}</span>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody className="pt-4 ps-4 pe-4 border-top">
                  <h4 className="mb-3">Pemilihan Unit</h4>
                  <div className="table-responsive mb-3 table-card">
                    <Table className="invoice-table table-borderless table-nowrap mb-0">
                      <thead className="align-middle">
                        <tr className="table-active">
                          <td style={{ width: "20px" }}>#</td>
                          <td>Unit Yang Dipilih</td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Harga Jual
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Booking Fee
                          </td>
                          <td className="text-center" style={{ width: "150px" }}>
                            Administrasi
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            {"> Tanah"}
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            {"Total > Tanah"}
                          </td>
                        </tr>
                      </thead>
                      <tbody id="newlink">
                        {(info.sales_detail || [])
                          .sort((a, b) => a.transaction_no - b.transaction_no)
                          .map((o, i) => {
                            return (
                              <tr key={i} id={i} className="product">
                                <td className="product-id">{i + 1}</td>
                                <td className="text-start">{o.name}</td>
                                <td className="text-center fs-14">{currencyFormat(o.amount)}</td>
                                <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(info.book_amount)}</td>
                                <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(o.price_handling)}</td>
                                <td className="text-center fs-14">
                                  {parseInt(o.land_excess) || 0} M<sup>2</sup> <span className="fs-12">({currencyFormat(o.land_price || 0)})</span>
                                </td>
                                <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(parseFloat(o.land_price) * parseFloat(o.land_excess) || 0)}</td>
                              </tr>
                            );
                          })}
                        <tbody></tbody>
                        {info.sales_detail && info.sales_detail.length === 0 && (
                          <tr>
                            <td colSpan="7" className="p-3 text-center fs-14">
                              Unit belum ditambahkan
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    <h4 className="mb-3 mt-3 pt-3 border-top">
                      History Pembayaran{" "}
                      {loadingAccTranss && (
                        <>
                          <Spinner color="primary" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                          <Spinner color="success" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                        </>
                      )}
                    </h4>
                    <div className="pt-3 ps-3 pe-3">
                      <div className="table-responsive mb-3 table-card">
                        <Table className="invoice-table table-borderless table-nowrap mb-0">
                          <thead className="align-middle">
                            <tr className="table-active">
                              <td style={{ width: "20px" }}>#</td>
                              <td>No Transaksi</td>
                              <td>Tanggal Transaksi</td>
                              <td>Keterangan</td>
                              <td className="text-end" style={{ width: "170px" }}>
                                Jumlah
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            {(accTransData || []).map((o, i) => {
                              return (
                                <tr key={i}>
                                  <td className="product-id">{i + 1}</td>
                                  <td>{o.transaction_no}</td>
                                  <td>{handleValidDate(o.transactionat)}</td>
                                  <td>{o.description}</td>
                                  <td className="text-end" style={{ width: "170px" }}>
                                    {currencyFormat(o.amount)}
                                  </td>
                                </tr>
                              );
                            })}
                            <tbody></tbody>
                            {accTransData && accTransData.length === 0 && (
                              <tr>
                                <td colSpan="3" className="p-3 text-center fs-14">
                                  Belum ada transaksi Penerimaan
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    {info.credit_amount && info.credit_amount > 0 && (
                      <div className="row border-top">
                        <div className="col-lg-5 mt-3">
                          <div className="mb-3">
                            <label className="text-muted">Maksimum KPR : </label>
                            <div className="fw-semibold fs-16">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount ?? 0) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) || 0)}</div>
                          </div>
                          <div className="mb-3">
                            <label className="text-muted">ACC KPR : </label>
                            <div className={currencyFormat(info.credit_amount) ? "fw-semibold text-success fs-16" : "fw-semibold fs-16"}>{currencyFormat(info.credit_amount)}</div>
                          </div>
                          <div className="row">
                            <div className="mb-1 col-lg-12">
                              <label>Tanggal SP3K</label> {handleValidDate(info.bankat)} (Tenor {info.tenor})
                            </div>
                          </div>
                          <div className="mb-1">
                            <label>Status : </label> <span className="fw-semibold fs-14">{info.sales_bank_status && info.sales_bank_status.name}</span>
                          </div>
                          <div className="mb-3">
                            <label>Keterangan Bank : </label> {info.description_bank ? info.description_bank : "-"}
                          </div>
                        </div>
                        <div className="col-lg-3"></div>
                        <div className="col-lg-4 mt-3">
                          <div className="mb-3">
                            <label className="text-muted">Penurunan KPR : </label>
                            <div className="fw-semibold fs-16 text-danger">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) - info.credit_amount || 0)}</div>
                          </div>
                          <div className="mb-3">
                            <label className="text-muted">TOTAL HARUS BAYAR : </label>
                            <div className="fw-semibold text-danger fs-16">{currencyFormat(info.total_amount)}</div>
                          </div>
                        </div>
                      </div>
                    )}

                    {info.completedat && (
                      <div className="pt-4 border-top">
                        <h4 className="mb-3">Jadwal Akad</h4>
                        <div className="row">
                          <div className="mb-3 col-lg-4">
                            <label>Tanggal Akad : </label> <span className="fw-semibold text-success fs-16">{info.completedat && handleValidDate(info.completedat)}</span>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="pt-4 border-top">
                      <h4 className="mb-3">Bukti Transaksi</h4>
                      <div className="mb-3">
                        {info.sales_file &&
                          info.sales_file.length > 0 &&
                          info.sales_file.map((f, i) => {
                            if (f.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                        <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                      ) : (
                                        <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                          <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                        </Link>
                                      )}
                                    </div>

                                    <div className="text-truncate">{f.originalname}</div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </ModalBody>
            ) : isBuildingProgress || isBuildingOpname ? (
              <ModalBody>
                <CardBody className="pt-4 ps-4 pe-4">
                  <Row className="mb-4">
                    <div className="col-lg-5">
                      {civilBudgetList.map((obj, i) => {
                        let arr = isBuildingProgress ? (obj.data || []).filter((f) => f.type === "PROGRESS BANGUNAN") : (obj.data || []).filter((f) => f.type === "UPAH");
                        return isBuildingProgress && obj.type === "PROGRESS BANGUNAN" ? (
                          <div key={i} className={"mb-3"}>
                            <p className="fw-semibold fs-14 text-uppercase m-1">{obj.category}</p>
                            <div className={"pe-3 ps-3 row"}>
                              {(arr || []).map((o, idx) => {
                                let ischecked = false;
                                if (info.checked_progress ? (info.checked_progress.split(",").find((x) => x === o.cvld_account.id.toString()) ? true : false) : false) {
                                  ischecked = true;
                                }
                                return (
                                  <div key={idx} className="hstack gap 2 mb-2">
                                    <em className="avatar-xs rounded-circle" style={{ background: o.cvld_account.color, width: "20px", height: "18px", display: "block", float: "left" }}>
                                      &nbsp;
                                    </em>
                                    <div className="ms-2">
                                      <Label className={ischecked ? "form-check-label fw-semibold fs-12 text-uppercase" : "form-check-label fs-12 text-uppercase text-muted"}>
                                        <i className={ischecked ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line me-1"}></i> {o.cvld_account.name}
                                      </Label>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : isBuildingOpname && obj.type === "UPAH" ? (
                          <div key={i} className={"mb-3"}>
                            <p className="fw-semibold fs-14 text-uppercase m-1">{obj.category}</p>
                            <div className={"pe-3 ps-3 row"}>
                              {(arr || []).map((o, idx) => {
                                let ischecked = false;
                                if (info.checked_progress ? (info.checked_progress.split(",").find((x) => x === o.cvld_account.id.toString()) ? true : false) : false) {
                                  ischecked = true;
                                }
                                return (
                                  <div key={idx} className="hstack gap 2 mb-2">
                                    <em className="avatar-xs rounded-circle" style={{ background: o.cvld_account.color, width: "20px", height: "18px", display: "block", float: "left" }}>
                                      &nbsp;
                                    </em>
                                    <div className="ms-2">
                                      <Label className={ischecked ? "form-check-label fw-semibold fs-12 text-uppercase" : "form-check-label fs-12 text-uppercase text-muted"}>
                                        <i className={ischecked ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line me-1"}></i> {o.cvld_account.name}
                                      </Label>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : null;
                      })}
                    </div>
                    <div className="col-lg-7">
                      <h4 className="card-title mb-4 flex-grow-1">
                        History progress &nbsp;
                        {civilProgressionLoading && (
                          <>
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </>
                        )}
                      </h4>
                      <div className="accordionflush">
                        {(civilProgressions || []).map((item, idx) => {
                          return (
                            <div key={idx} className="accordion-item border-0">
                              <div className="accordion-header">
                                <div className="accordion-button p-2 shadow-none" id="headingOne">
                                  <div className="d-flex w-100">
                                    <div className="flex-shrink-0 me-1">
                                      {item?.cvlp_createdby && item?.cvlp_createdby?.image ? (
                                        <div className="profile-user position-relative d-inline-block mx-auto">
                                          <img src={`${api.MEDIA_URL}/media/${item?.cvlp_createdby?.image}-w-200`} alt="" className="rounded-circle avatar-sm img-thumbnail user-profile-image" />
                                        </div>
                                      ) : (
                                        <div className="flex-shrink-0 avatar-sm">
                                          <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.cvlp_createdby?.name.charAt(0)}</div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="fs-14 mb-1">{item.cvlp_createdby.name}</h6>
                                        {item.cvlp_file.length > 0 && <PrintDocx data={item} />}
                                      </div>
                                      <p className="fw-normal text-muted mb-1">Memperbarui progress pembangunan dengan catatan:</p>
                                      <p className="fw-normal mb-1">{item.description || "-"}</p>
                                      <small className="text-muted">
                                        <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}
                                      </small>
                                      <div className="row mt-3">
                                        {item.cvlp_file.map((f, i) => {
                                          return (
                                            <div key={i} className="col-lg-4">
                                              <div className="position-relative d-inline-block mx-auto">
                                                <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Row>
                </CardBody>
              </ModalBody>
            ) : (
              <ModalBody>
                <CardBody className="pt-4 ps-4 pe-4">{info.description && parse(info.description)}</CardBody>
              </ModalBody>
            )}
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-lg btn-light"
                  onClick={() => {
                    setModal(false);
                  }}
                >
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Modal id="showModal" isOpen={modalMaterial} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggleMaterial}>
              DETAIL REALISASI ANGGARAN {label}
            </ModalHeader>
            <ModalBody>
              <CardBody>
                <div>
                  <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                    <div className="col-sm-10">
                      <Row className="m-0 p-0 ">
                        <div className="fw-semibold col-sm-5 text-start">
                          <input className="search-box  w-100 form-control" placeholder="Filter Material / Transaksi" onChange={(e) => searchList(e.target.value)} />
                        </div>
                      </Row>
                    </div>
                    <div className="col-sm-2 text-end">
                      <ExportDoc data={printDetailDoc} />
                    </div>
                  </Row>
                  <SimpleBar style={{ height: "380px" }}>
                    <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                      <thead className="align-middle">
                        <tr className="table-active">
                          <td style={{ width: "20px" }}>
                            <input
                              type="checkbox"
                              className="checkboxDetailAll me-2 form-check-input"
                              checked={expense.every((item) => item.isChecked)}
                              onChange={() => {
                                const allChecked = expense.every((item) => item.isChecked);
                                const updatedData = expense.map((item) => ({
                                  ...item,
                                  isChecked: !allChecked,
                                }));
                                setExpense(updatedData);
                              }}
                            />
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Tanggal
                          </td>
                          <td>Material</td>
                          <td className="text-center" style={{ width: "170px" }}>
                            No Transaksi
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Jumlah
                          </td>
                          <td className="text-center">Keterangan</td>
                        </tr>
                      </thead>
                      <tbody id="newlink">
                        {(expense || []).map((o, i) => {
                          return (
                            <tr key={i} id={i} className="product">
                              <td className="product-id">
                                <input
                                  type="checkbox"
                                  className="checkboxDetail me-2 form-check-input"
                                  checked={o.isChecked}
                                  onChange={() => {
                                    const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                    setExpense(updatedData);
                                  }}
                                />{" "}
                                {i + 1}
                              </td>
                              <td className="text-center">{handleValidDate(o.transactionat)}</td>
                              <td className="text-start">{o.name}</td>
                              <td className="text-center">{o.transaction_no}</td>
                              <td className="text-center">{currencyFormat(parseFloat(o.amount))}</td>
                              <td className="text-center">{o.description}</td>
                            </tr>
                          );
                        })}
                        {expense.length === 0 && (
                          <tr>
                            <td colSpan="7" className="p-3 text-center">
                              Belum ada realisasi
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </SimpleBar>
                </div>
              </CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalMaterial(false);
                  }}
                >
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Card id="dashboard-custom-tooltip" className="border">
            {isBuildingProgress || isBuildingProgress ? (
              <CardBody className={info && info.weight ? "" : "d-none"}>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-md me-3 flex-shrink-0">
                    <div className="avatar-title bg-soft-info rounded">
                      <img src={info.image} alt="" className="avatar-md" />
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h5 className="fs-15 fw-bold mb-1">{info && info.name}</h5>
                    <div className="mb-1">
                      Bobot Tercapai <span className="fw-semibold">{info.weight ? info.weight : 0} %</span>
                    </div>
                    <div className="mb-1" style={{ clear: "both" }}>
                      <em className="avatar-xs" style={{ background: info.color, width: "22px", height: "22px", display: "block", float: "left", marginRight: "5px" }}>
                        &nbsp;
                      </em>{" "}
                      {info.progress}
                    </div>
                  </div>
                </div>
              </CardBody>
            ) : (
              <CardBody className={info && info.sales_customer && info.sales_customer.name ? "" : "d-none"}>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-md me-3 flex-shrink-0">
                    <div className="avatar-title bg-soft-info rounded">
                      <img src={info.image} alt="" className="avatar-md" />
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="text-muted mb-1">{info && info.name}</p>
                    <h5 className="fs-15 fw-bold mb-2">{info && info.sales_customer && info.sales_customer.name}</h5>
                    {/* <p className="mb-0">{info && info.sales_customer && info.sales_customer.phone}</p> */}
                    <p className="hstack gap-2">
                      {info && info.sales_deal_status && info.sales_deal_status.id === 3 && (info.typeId === 1 || info.typeId === 2) && (
                        <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ed57f7" }}>
                          {info.sales_deal_status.name}
                        </span>
                      )}
                      {info && info.sales_deal_status && info.sales_deal_status.id === 3 && (info.typeId === 3 || info.typeId === 4) && (
                        <span className="badge text-uppercase" style={{ background: "#20A7DB", color: "#FFFFFF" }}>
                          CASH
                        </span>
                      )}
                      {info && info.sales_deal_status && info.sales_deal_status.id === 4 && (
                        <span className="badge text-uppercase" style={{ background: "#D5C7A3", color: "#443627" }}>
                          {info.sales_deal_status.name}
                        </span>
                      )}
                      {info && info.sales_deal_status && info.sales_deal_status.id === 5 && (
                        <span className="badge text-uppercase" style={{ background: "#EEF1DA", color: "#255F38" }}>
                          {info.sales_deal_status.name}
                        </span>
                      )}
                      {info && info.sales_deal_status && info.sales_deal_status.id === 6 && (
                        <span className="badge text-uppercase" style={{ background: "#FFFBCA", color: "#F09319" }}>
                          {info.sales_deal_status.name}
                        </span>
                      )}
                      {info && info.sales_deal_status && info.sales_deal_status.id === 7 && <span className="badge text-uppercase badge-soft-info">{info.sales_deal_status.name}</span>}
                      {info && info.sales_deal_status && info.sales_deal_status.id === 8 && (
                        <span className="badge text-uppercase" style={{ background: "#bffcfc", color: "#2cc2c4" }}>
                          {info.sales_deal_status.name}
                        </span>
                      )}

                      {info && info.sales_bank_status && info.sales_bank_status.id === 1 && <span className="badge text-uppercase badge-soft-success">{info.sales_bank_status.name}</span>}
                      {info && info.sales_bank_status && info.sales_bank_status.id === 2 && <span className="badge text-uppercase badge-soft-warning">{info.sales_bank_status.name}</span>}
                      {info && info.sales_bank_status && info.sales_bank_status.id === 3 && <span className="badge text-uppercase badge-soft-danger">{info.sales_bank_status.name}</span>}
                    </p>
                  </div>
                </div>
                <p className="pb-1">Sales : {info && info.sales_agent && info.sales_agent.name}</p>
                <Row className="mb-4">
                  <div className="profile-timeline">
                    <div></div>
                    <div className="accordion accordion-flush" id="todayExample" style={{ overflow: "scroll", height: "400px" }}>
                      {info &&
                        info.sales_history &&
                        info.sales_history.map((item, i) => {
                          return (
                            <div key={i} className="accordion-item border-0">
                              <div className="accordion-header">
                                <button className="accordion-button p-2 shadow-none" type="button" id="headingOne">
                                  <div className="d-flex">
                                    <div className="flex-shrink-0 me-1">
                                      {item?.sales_history_createdby && item?.sales_history_createdby?.image ? (
                                        <div className="profile-user position-relative d-inline-block mx-auto">
                                          <img src={`${api.MEDIA_URL}/media/${item?.sales_history_createdby?.image}-w-200`} alt="" className="rounded-circle avatar-sm img-thumbnail user-profile-image" />
                                        </div>
                                      ) : (
                                        <div className="flex-shrink-0 avatar-sm">
                                          <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.sales_history_createdby?.name.charAt(0)}</div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      <h6 className="fs-14 mb-1">{item?.sales_history_createdby?.name}</h6>
                                      <p className="fw-normal text-muted mb-1">
                                        Memperbarui status penjualan menjadi <span className="fw-semibold text-info">{item?.sales_history_status && item?.sales_history_status?.name}</span> dan progress KPR menjadi
                                        <span className="fw-semibold ms-2 text-success">{item?.sales_history_status_deal && item?.sales_history_status_deal.name}</span> dengan catatan:
                                      </p>
                                      <p className="fw-normal mb-1">{item.comment || "-"}</p>
                                      <small className="text-muted">
                                        <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}
                                      </small>
                                    </div>
                                  </div>
                                </button>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Row>
              </CardBody>
            )}
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
